/*!
 * jquery-timepicker v1.11.11 - A jQuery timepicker plugin inspired by Google Calendar. It supports both mouse and keyboard navigation.
 * Copyright (c) 2017 Jon Thornton - http://jonthornton.github.com/jquery-timepicker/
 * License: MIT
 */


!function(a){"object"==typeof exports&&exports&&"object"==typeof module&&module&&module.exports===exports?a(require("jquery")):"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){function b(a){var b=a[0];return b.offsetWidth>0&&b.offsetHeight>0}function c(b){if(b.minTime&&(b.minTime=t(b.minTime)),b.maxTime&&(b.maxTime=t(b.maxTime)),b.durationTime&&"function"!=typeof b.durationTime&&(b.durationTime=t(b.durationTime)),"now"==b.scrollDefault)b.scrollDefault=function(){return b.roundingFunction(t(new Date),b)};else if(b.scrollDefault&&"function"!=typeof b.scrollDefault){var c=b.scrollDefault;b.scrollDefault=function(){return b.roundingFunction(t(c),b)}}else b.minTime&&(b.scrollDefault=function(){return b.roundingFunction(b.minTime,b)});if("string"===a.type(b.timeFormat)&&b.timeFormat.match(/[gh]/)&&(b._twelveHourTime=!0),b.showOnFocus===!1&&-1!=b.showOn.indexOf("focus")&&b.showOn.splice(b.showOn.indexOf("focus"),1),b.disableTimeRanges.length>0){for(var d in b.disableTimeRanges)b.disableTimeRanges[d]=[t(b.disableTimeRanges[d][0]),t(b.disableTimeRanges[d][1])];b.disableTimeRanges=b.disableTimeRanges.sort(function(a,b){return a[0]-b[0]});for(var d=b.disableTimeRanges.length-1;d>0;d--)b.disableTimeRanges[d][0]<=b.disableTimeRanges[d-1][1]&&(b.disableTimeRanges[d-1]=[Math.min(b.disableTimeRanges[d][0],b.disableTimeRanges[d-1][0]),Math.max(b.disableTimeRanges[d][1],b.disableTimeRanges[d-1][1])],b.disableTimeRanges.splice(d,1))}return b}function d(b){var c=b.data("timepicker-settings"),d=b.data("timepicker-list");if(d&&d.length&&(d.remove(),b.data("timepicker-list",!1)),c.useSelect){d=a("<select />",{"class":"ui-timepicker-select"});var g=d}else{d=a("<ul />",{"class":"ui-timepicker-list"});var g=a("<div />",{"class":"ui-timepicker-wrapper",tabindex:-1});g.css({display:"none",position:"absolute"}).append(d)}if(c.noneOption)if(c.noneOption===!0&&(c.noneOption=c.useSelect?"Time...":"None"),a.isArray(c.noneOption)){for(var i in c.noneOption)if(parseInt(i,10)==i){var k=e(c.noneOption[i],c.useSelect);d.append(k)}}else{var k=e(c.noneOption,c.useSelect);d.append(k)}if(c.className&&g.addClass(c.className),(null!==c.minTime||null!==c.durationTime)&&c.showDuration){"function"==typeof c.step?"function":c.step;g.addClass("ui-timepicker-with-duration"),g.addClass("ui-timepicker-step-"+c.step)}var l=c.minTime;"function"==typeof c.durationTime?l=t(c.durationTime()):null!==c.durationTime&&(l=c.durationTime);var n=null!==c.minTime?c.minTime:0,o=null!==c.maxTime?c.maxTime:n+v-1;n>o&&(o+=v),o===v-1&&"string"===a.type(c.timeFormat)&&c.show2400&&(o=v);var p=c.disableTimeRanges,w=0,x=p.length,z=c.step;"function"!=typeof z&&(z=function(){return c.step});for(var i=n,A=0;o>=i;A++,i+=60*z(A)){var B=i,C=s(B,c);if(c.useSelect){var D=a("<option />",{value:C});D.text(C)}else{var D=a("<li />");D.addClass(v/2>B%v?"ui-timepicker-am":"ui-timepicker-pm"),D.data("time",u(B,c)),D.text(C)}if((null!==c.minTime||null!==c.durationTime)&&c.showDuration){var E=r(i-l,c.step);if(c.useSelect)D.text(D.text()+" ("+E+")");else{var F=a("<span />",{"class":"ui-timepicker-duration"});F.text(" ("+E+")"),D.append(F)}}x>w&&(B>=p[w][1]&&(w+=1),p[w]&&B>=p[w][0]&&B<p[w][1]&&(c.useSelect?D.prop("disabled",!0):D.addClass("ui-timepicker-disabled"))),d.append(D)}if(g.data("timepicker-input",b),b.data("timepicker-list",g),c.useSelect)b.val()&&d.val(f(t(b.val()),c)),d.on("focus",function(){a(this).data("timepicker-input").trigger("showTimepicker")}),d.on("blur",function(){a(this).data("timepicker-input").trigger("hideTimepicker")}),d.on("change",function(){m(b,a(this).val(),"select")}),m(b,d.val(),"initial"),b.hide().after(d);else{var G=c.appendTo;"string"==typeof G?G=a(G):"function"==typeof G&&(G=G(b)),G.append(g),j(b,d),d.on("mousedown click","li",function(c){b.off("focus.timepicker"),b.on("focus.timepicker-ie-hack",function(){b.off("focus.timepicker-ie-hack"),b.on("focus.timepicker",y.show)}),h(b)||b[0].focus(),d.find("li").removeClass("ui-timepicker-selected"),a(this).addClass("ui-timepicker-selected"),q(b)&&(b.trigger("hideTimepicker"),d.on("mouseup.timepicker click.timepicker","li",function(a){d.off("mouseup.timepicker click.timepicker"),g.hide()}))})}}function e(b,c){var d,e,f;return"object"==typeof b?(d=b.label,e=b.className,f=b.value):"string"==typeof b?d=b:a.error("Invalid noneOption value"),c?a("<option />",{value:f,"class":e,text:d}):a("<li />",{"class":e,text:d}).data("time",String(f))}function f(a,b){return a=b.roundingFunction(a,b),null!==a?s(a,b):void 0}function g(b){if(b.target!=window){var c=a(b.target);c.closest(".ui-timepicker-input").length||c.closest(".ui-timepicker-wrapper").length||(y.hide(),a(document).unbind(".ui-timepicker"),a(window).unbind(".ui-timepicker"))}}function h(a){var b=a.data("timepicker-settings");return(window.navigator.msMaxTouchPoints||"ontouchstart"in document)&&b.disableTouchKeyboard}function i(b,c,d){if(!d&&0!==d)return!1;var e=b.data("timepicker-settings"),f=!1,d=e.roundingFunction(d,e);return c.find("li").each(function(b,c){var e=a(c);if("number"==typeof e.data("time"))return e.data("time")==d?(f=e,!1):void 0}),f}function j(a,b){b.find("li").removeClass("ui-timepicker-selected");var c=a.data("timepicker-settings"),d=t(l(a),c);if(null!==d){var e=i(a,b,d);if(e){var f=e.offset().top-b.offset().top;(f+e.outerHeight()>b.outerHeight()||0>f)&&b.scrollTop(b.scrollTop()+e.position().top-e.outerHeight()),(c.forceRoundTime||e.data("time")===d)&&e.addClass("ui-timepicker-selected")}}}function k(b,c){if("timepicker"!=c){var d=a(this);if(""===this.value)return void m(d,null,c);if(!d.is(":focus")||b&&"change"==b.type){var e=d.data("timepicker-settings"),f=t(this.value,e);if(null===f)return void d.trigger("timeFormatError");var g=!1;if(null!==e.minTime&&null!==e.maxTime&&(f<e.minTime||f>e.maxTime)&&(g=!0),a.each(e.disableTimeRanges,function(){return f>=this[0]&&f<this[1]?(g=!0,!1):void 0}),e.forceRoundTime){var h=e.roundingFunction(f,e);h!=f&&(f=h,c=null)}var i=s(f,e);g?(m(d,i,"error")||b&&"change"==b.type)&&d.trigger("timeRangeError"):m(d,i,c)}}}function l(a){return a.is("input")?a.val():a.data("ui-timepicker-value")}function m(a,b,c){if(a.is("input")){a.val(b);var d=a.data("timepicker-settings");d.useSelect&&"select"!=c&&"initial"!=c&&a.data("timepicker-list").val(f(t(b),d))}return a.data("ui-timepicker-value")!=b?(a.data("ui-timepicker-value",b),"select"==c?a.trigger("selectTime").trigger("changeTime").trigger("change","timepicker"):-1==["error","initial"].indexOf(c)&&a.trigger("changeTime"),!0):(a.trigger("selectTime"),!1)}function n(a){switch(a.keyCode){case 13:case 9:return;default:a.preventDefault()}}function o(c){var d=a(this),e=d.data("timepicker-list");if(!e||!b(e)){if(40!=c.keyCode)return!0;y.show.call(d.get(0)),e=d.data("timepicker-list"),h(d)||d.focus()}switch(c.keyCode){case 13:return q(d)&&(k.call(d.get(0),{type:"change"}),y.hide.apply(this)),c.preventDefault(),!1;case 38:var f=e.find(".ui-timepicker-selected");return f.length?f.is(":first-child")||(f.removeClass("ui-timepicker-selected"),f.prev().addClass("ui-timepicker-selected"),f.prev().position().top<f.outerHeight()&&e.scrollTop(e.scrollTop()-f.outerHeight())):(e.find("li").each(function(b,c){return a(c).position().top>0?(f=a(c),!1):void 0}),f.addClass("ui-timepicker-selected")),!1;case 40:return f=e.find(".ui-timepicker-selected"),0===f.length?(e.find("li").each(function(b,c){return a(c).position().top>0?(f=a(c),!1):void 0}),f.addClass("ui-timepicker-selected")):f.is(":last-child")||(f.removeClass("ui-timepicker-selected"),f.next().addClass("ui-timepicker-selected"),f.next().position().top+2*f.outerHeight()>e.outerHeight()&&e.scrollTop(e.scrollTop()+f.outerHeight())),!1;case 27:e.find("li").removeClass("ui-timepicker-selected"),y.hide();break;case 9:y.hide();break;default:return!0}}function p(c){var d=a(this),e=d.data("timepicker-list"),f=d.data("timepicker-settings");if(!e||!b(e)||f.disableTextInput)return!0;if("paste"===c.type||"cut"===c.type)return void setTimeout(function(){f.typeaheadHighlight?j(d,e):e.hide()},0);switch(c.keyCode){case 96:case 97:case 98:case 99:case 100:case 101:case 102:case 103:case 104:case 105:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:case 65:case 77:case 80:case 186:case 8:case 46:f.typeaheadHighlight?j(d,e):e.hide()}}function q(a){var b=a.data("timepicker-settings"),c=a.data("timepicker-list"),d=null,e=c.find(".ui-timepicker-selected");return e.hasClass("ui-timepicker-disabled")?!1:(e.length&&(d=e.data("time")),null!==d&&("string"!=typeof d&&(d=s(d,b)),m(a,d,"select")),!0)}function r(a,b){a=Math.abs(a);var c,d,e=Math.round(a/60),f=[];return 60>e?f=[e,w.mins]:(c=Math.floor(e/60),d=e%60,30==b&&30==d&&(c+=w.decimal+5),f.push(c),f.push(1==c?w.hr:w.hrs),30!=b&&d&&(f.push(d),f.push(w.mins))),f.join(" ")}function s(b,c){if("number"!=typeof b)return null;var d=parseInt(b%60),e=parseInt(b/60%60),f=parseInt(b/3600%24),g=new Date(1970,0,2,f,e,d,0);if(isNaN(g.getTime()))return null;if("function"===a.type(c.timeFormat))return c.timeFormat(g);for(var h,i,j="",k=0;k<c.timeFormat.length;k++)switch(i=c.timeFormat.charAt(k)){case"a":j+=g.getHours()>11?w.pm:w.am;break;case"A":j+=g.getHours()>11?w.PM:w.AM;break;case"g":h=g.getHours()%12,j+=0===h?"12":h;break;case"G":h=g.getHours(),b===v&&(h=c.show2400?24:0),j+=h;break;case"h":h=g.getHours()%12,0!==h&&10>h&&(h="0"+h),j+=0===h?"12":h;break;case"H":h=g.getHours(),b===v&&(h=c.show2400?24:0),j+=h>9?h:"0"+h;break;case"i":var e=g.getMinutes();j+=e>9?e:"0"+e;break;case"s":d=g.getSeconds(),j+=d>9?d:"0"+d;break;case"\\":k++,j+=c.timeFormat.charAt(k);break;default:j+=i}return j}function t(a,b){if(""===a||null===a)return null;if("object"==typeof a)return 3600*a.getHours()+60*a.getMinutes()+a.getSeconds();if("string"!=typeof a)return a;a=a.toLowerCase().replace(/[\s\.]/g,""),("a"==a.slice(-1)||"p"==a.slice(-1))&&(a+="m");var c="("+w.am.replace(".","")+"|"+w.pm.replace(".","")+"|"+w.AM.replace(".","")+"|"+w.PM.replace(".","")+")?",d=new RegExp("^"+c+"([0-9]?[0-9])\\W?([0-5][0-9])?\\W?([0-5][0-9])?"+c+"$"),e=a.match(d);if(!e)return null;var f=parseInt(1*e[2],10),g=e[1]||e[5],h=f,i=1*e[3]||0,j=1*e[4]||0;if(12>=f&&g){var k=g==w.pm||g==w.PM;h=12==f?k?12:0:f+(k?12:0)}else if(b){var l=3600*f+60*i+j;if(l>=v+(b.show2400?1:0)){if(b.wrapHours===!1)return null;h=f%24}}var m=3600*h+60*i+j;if(12>f&&!g&&b&&b._twelveHourTime&&b.scrollDefault){var n=m-b.scrollDefault();0>n&&n>=v/-2&&(m=(m+v/2)%v)}return m}function u(a,b){return a==v&&b.show2400?a:a%v}var v=86400,w={am:"am",pm:"pm",AM:"AM",PM:"PM",decimal:".",mins:"mins",hr:"hr",hrs:"hrs"},x={appendTo:"body",className:null,closeOnWindowScroll:!1,disableTextInput:!1,disableTimeRanges:[],disableTouchKeyboard:!1,durationTime:null,forceRoundTime:!1,maxTime:null,minTime:null,noneOption:!1,orientation:"l",roundingFunction:function(a,b){if(null===a)return null;if("number"!=typeof b.step)return a;var c=a%(60*b.step),d=b.minTime||0;return c-=d%(60*b.step),c>=30*b.step?a+=60*b.step-c:a-=c,u(a,b)},scrollDefault:null,selectOnBlur:!1,show2400:!1,showDuration:!1,showOn:["click","focus"],showOnFocus:!0,step:30,stopScrollPropagation:!1,timeFormat:"g:ia",typeaheadHighlight:!0,useSelect:!1,wrapHours:!0},y={init:function(b){return this.each(function(){var e=a(this),f=[];for(var g in x)e.data(g)&&(f[g]=e.data(g));var h=a.extend({},x,b,f);if(h.lang&&(w=a.extend(w,h.lang)),h=c(h),e.data("timepicker-settings",h),e.addClass("ui-timepicker-input"),h.useSelect)d(e);else{if(e.prop("autocomplete","off"),h.showOn)for(var i in h.showOn)e.on(h.showOn[i]+".timepicker",y.show);e.on("change.timepicker",k),e.on("keydown.timepicker",o),e.on("keyup.timepicker",p),h.disableTextInput&&e.on("keydown.timepicker",n),e.on("cut.timepicker",p),e.on("paste.timepicker",p),k.call(e.get(0),null,"initial")}})},show:function(c){var e=a(this),f=e.data("timepicker-settings");if(c&&c.preventDefault(),f.useSelect)return void e.data("timepicker-list").focus();h(e)&&e.blur();var k=e.data("timepicker-list");if(!e.prop("readonly")&&(k&&0!==k.length&&"function"!=typeof f.durationTime||(d(e),k=e.data("timepicker-list")),!b(k))){e.data("ui-timepicker-value",e.val()),j(e,k),y.hide(),k.show();var m={};f.orientation.match(/r/)?m.left=e.offset().left+e.outerWidth()-k.outerWidth()+parseInt(k.css("marginLeft").replace("px",""),10):m.left=e.offset().left+parseInt(k.css("marginLeft").replace("px",""),10);var n;n=f.orientation.match(/t/)?"t":f.orientation.match(/b/)?"b":e.offset().top+e.outerHeight(!0)+k.outerHeight()>a(window).height()+a(window).scrollTop()?"t":"b","t"==n?(k.addClass("ui-timepicker-positioned-top"),m.top=e.offset().top-k.outerHeight()+parseInt(k.css("marginTop").replace("px",""),10)):(k.removeClass("ui-timepicker-positioned-top"),m.top=e.offset().top+e.outerHeight()+parseInt(k.css("marginTop").replace("px",""),10)),k.offset(m);var o=k.find(".ui-timepicker-selected");if(!o.length){var p=t(l(e));null!==p?o=i(e,k,p):f.scrollDefault&&(o=i(e,k,f.scrollDefault()))}if((!o.length||o.hasClass("ui-timepicker-disabled"))&&(o=k.find("li:not(.ui-timepicker-disabled):first")),o&&o.length){var q=k.scrollTop()+o.position().top-o.outerHeight();k.scrollTop(q)}else k.scrollTop(0);return f.stopScrollPropagation&&a(document).on("wheel.ui-timepicker",".ui-timepicker-wrapper",function(b){b.preventDefault();var c=a(this).scrollTop();a(this).scrollTop(c+b.originalEvent.deltaY)}),a(document).on("touchstart.ui-timepicker mousedown.ui-timepicker",g),a(window).on("resize.ui-timepicker",g),f.closeOnWindowScroll&&a(document).on("scroll.ui-timepicker",g),e.trigger("showTimepicker"),this}},hide:function(c){var d=a(this),e=d.data("timepicker-settings");return e&&e.useSelect&&d.blur(),a(".ui-timepicker-wrapper").each(function(){var c=a(this);if(b(c)){var d=c.data("timepicker-input"),e=d.data("timepicker-settings");e&&e.selectOnBlur&&q(d),c.hide(),d.trigger("hideTimepicker")}}),this},option:function(b,e){return"string"==typeof b&&"undefined"==typeof e?a(this).data("timepicker-settings")[b]:this.each(function(){var f=a(this),g=f.data("timepicker-settings"),h=f.data("timepicker-list");"object"==typeof b?g=a.extend(g,b):"string"==typeof b&&(g[b]=e),g=c(g),f.data("timepicker-settings",g),k.call(f.get(0),{type:"change"},"initial"),h&&(h.remove(),f.data("timepicker-list",!1)),g.useSelect&&d(f)})},getSecondsFromMidnight:function(){return t(l(this))},getTime:function(a){var b=this,c=l(b);if(!c)return null;var d=t(c);if(null===d)return null;a||(a=new Date);var e=new Date(a);return e.setHours(d/3600),e.setMinutes(d%3600/60),e.setSeconds(d%60),e.setMilliseconds(0),e},isVisible:function(){var a=this,c=a.data("timepicker-list");return!(!c||!b(c))},setTime:function(a){var b=this,c=b.data("timepicker-settings");if(c.forceRoundTime)var d=f(t(a),c);else var d=s(t(a),c);return a&&null===d&&c.noneOption&&(d=a),b.val(d),k.call(b.get(0),{type:"change"},"initial"),b.data("timepicker-list")&&j(b,b.data("timepicker-list")),this},remove:function(){var a=this;if(a.hasClass("ui-timepicker-input")){var b=a.data("timepicker-settings");return a.removeAttr("autocomplete","off"),a.removeClass("ui-timepicker-input"),a.removeData("timepicker-settings"),a.off(".timepicker"),a.data("timepicker-list")&&a.data("timepicker-list").remove(),b.useSelect&&a.show(),a.removeData("timepicker-list"),this}}};a.fn.timepicker=function(b){return this.length?y[b]?this.hasClass("ui-timepicker-input")?y[b].apply(this,Array.prototype.slice.call(arguments,1)):this:"object"!=typeof b&&b?void a.error("Method "+b+" does not exist on jQuery.timepicker"):y.init.apply(this,arguments):this}});
//! moment-timezone.js
//! version : 0.5.14
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof define === 'function' && define.amd) {
		define(['moment'], factory);                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.14",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	loadData({
		"version": "2017c",
		"zones": [
			"Africa/Abidjan|GMT|0|0||48e5",
			"Africa/Nairobi|EAT|-30|0||47e5",
			"Africa/Algiers|CET|-10|0||26e5",
			"Africa/Lagos|WAT|-10|0||17e6",
			"Africa/Maputo|CAT|-20|0||26e5",
			"Africa/Cairo|EET EEST|-20 -30|01010|1M2m0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|WET WEST|0 -10|0101010101010101010101010101010101010101010|1H3C0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00|32e5",
			"Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|11e6",
			"Africa/Johannesburg|SAST|-20|0||84e5",
			"Africa/Khartoum|EAT CAT|-30 -20|01|1Usl0|51e5",
			"Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00|11e5",
			"Africa/Windhoek|WAST WAT CAT|-20 -10 -20|0101010101012|1GQo0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|HST HDT|a0 90|01010101010101010101010|1GIc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1GIb0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|30e4",
			"America/Santo_Domingo|AST|40|0||29e5",
			"America/Araguaina|-03 -02|30 20|010|1IdD0 Lz0|14e4",
			"America/Fortaleza|-03|30|0||34e5",
			"America/Asuncion|-03 -04|30 40|01010101010101010101010|1GTf0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0|28e5",
			"America/Panama|EST|50|0||15e5",
			"America/Bahia|-02 -03|20 30|01|1GCq0|27e5",
			"America/Mexico_City|CST CDT|60 50|01010101010101010101010|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
			"America/Managua|CST|60|0||22e5",
			"America/La_Paz|-04|40|0||19e5",
			"America/Lima|-05|50|0||11e6",
			"America/Denver|MST MDT|70 60|01010101010101010101010|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|26e5",
			"America/Campo_Grande|-03 -04|30 40|01010101010101010101010|1GCr0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0|77e4",
			"America/Cancun|CST CDT EST|60 50 50|01010102|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|-0430 -04|4u 40|01|1QMT0|29e5",
			"America/Chicago|CST CDT|60 50|01010101010101010101010|1GI80 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|MST MDT|70 60|01010101010101010101010|1GQx0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
			"America/Phoenix|MST|70|0||42e5",
			"America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|15e6",
			"America/New_York|EST EDT|50 40|01010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|21e6",
			"America/Rio_Branco|-04 -05|40 50|01|1KLE0|31e4",
			"America/Fort_Nelson|PST PDT MST|80 70 70|01010102|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Halifax|AST ADT|40 30|01010101010101010101010|1GI60 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|39e4",
			"America/Godthab|-03 -02|30 20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|17e3",
			"America/Grand_Turk|EST EDT AST|50 40 40|0101010121010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|37e2",
			"America/Havana|CST CDT|50 40|01010101010101010101010|1GQt0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0|21e5",
			"America/Metlakatla|PST AKST AKDT|80 90 80|0121212121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|14e2",
			"America/Miquelon|-03 -02|30 20|01010101010101010101010|1GI50 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|61e2",
			"America/Montevideo|-02 -03|20 30|01010101|1GI40 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Noronha|-02|20|0||30e2",
			"America/Port-au-Prince|EST EDT|50 40|010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|23e5",
			"Antarctica/Palmer|-03 -04|30 40|010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"America/Santiago|-03 -04|30 40|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0|62e5",
			"America/Sao_Paulo|-02 -03|20 30|01010101010101010101010|1GCq0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0|20e6",
			"Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e4",
			"America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1GI5u 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|11e4",
			"Antarctica/Casey|+11 +08|-b0 -80|010|1GAF0 blz0|10",
			"Antarctica/Davis|+05 +07|-50 -70|01|1GAI0|70",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Pacific/Guadalcanal|+11|-b0|0||11e4",
			"Asia/Tashkent|+05|-50|0||23e5",
			"Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
			"Asia/Baghdad|+03|-30|0||66e5",
			"Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|40",
			"Asia/Dhaka|+06|-60|0||16e6",
			"Asia/Amman|EET EEST|-20 -30|010101010101010101010|1GPy0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00|25e5",
			"Asia/Kamchatka|+12|-c0|0||18e4",
			"Asia/Baku|+04 +05|-40 -50|010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|+07|-70|0||15e6",
			"Asia/Barnaul|+07 +06|-70 -60|010|1N7v0 3rd0",
			"Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1GNy0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|22e5",
			"Asia/Manila|+08|-80|0||24e6",
			"Asia/Kolkata|IST|-5u|0||15e6",
			"Asia/Chita|+10 +08 +09|-a0 -80 -90|012|1N7s0 3re0|33e4",
			"Asia/Ulaanbaatar|+08 +09|-80 -90|01010|1O8G0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Shanghai|CST|-80|0||23e6",
			"Asia/Colombo|+0530|-5u|0||22e5",
			"Asia/Damascus|EET EEST|-20 -30|01010101010101010101010|1GPy0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|+09|-90|0||19e4",
			"Asia/Dubai|+04|-40|0||39e5",
			"Asia/Famagusta|EET EEST +03|-20 -30 -30|0101010101201010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0",
			"Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1GPy0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|18e5",
			"Asia/Hong_Kong|HKT|-80|0||73e5",
			"Asia/Hovd|+07 +08|-70 -80|01010|1O8H0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|+09 +08|-90 -80|01|1N7t0|60e4",
			"Europe/Istanbul|EET EEST +03|-20 -30 -30|01010101012|1GNB0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|WIB|-70|0||31e6",
			"Asia/Jayapura|WIT|-90|0||26e4",
			"Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1GPA0 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0|81e4",
			"Asia/Kabul|+0430|-4u|0||46e5",
			"Asia/Karachi|PKT|-50|0||24e6",
			"Asia/Kathmandu|+0545|-5J|0||12e5",
			"Asia/Yakutsk|+10 +09|-a0 -90|01|1N7s0|28e4",
			"Asia/Krasnoyarsk|+08 +07|-80 -70|01|1N7u0|10e5",
			"Asia/Magadan|+12 +10 +11|-c0 -a0 -b0|012|1N7q0 3Cq0|95e3",
			"Asia/Makassar|WITA|-80|0||15e5",
			"Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|35e5",
			"Asia/Novosibirsk|+07 +06|-70 -60|010|1N7v0 4eN0|15e5",
			"Asia/Omsk|+07 +06|-70 -60|01|1N7v0|12e5",
			"Asia/Pyongyang|KST KST|-90 -8u|01|1P4D0|29e5",
			"Asia/Rangoon|+0630|-6u|0||48e5",
			"Asia/Sakhalin|+11 +10|-b0 -a0|010|1N7r0 3rd0|58e4",
			"Asia/Seoul|KST|-90|0||23e6",
			"Asia/Srednekolymsk|+12 +11|-c0 -b0|01|1N7q0|35e2",
			"Asia/Tehran|+0330 +0430|-3u -4u|01010101010101010101010|1GLUu 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
			"Asia/Tokyo|JST|-90|0||38e6",
			"Asia/Tomsk|+07 +06|-70 -60|010|1N7v0 3Qp0|10e5",
			"Asia/Vladivostok|+11 +10|-b0 -a0|01|1N7r0|60e4",
			"Asia/Yekaterinburg|+06 +05|-60 -50|01|1N7w0|14e5",
			"Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|27e5",
			"Atlantic/Cape_Verde|-01|10|0||50e4",
			"Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1GQg0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1GQgu 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST|-a0|0||20e5",
			"Australia/Darwin|ACST|-9u|0||12e4",
			"Australia/Eucla|+0845|-8J|0||368",
			"Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1GQf0 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Perth|AWST|-80|0||18e5",
			"Pacific/Easter|-05 -06|50 60|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0|30e2",
			"Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|12e5",
			"Pacific/Tahiti|-10|a0|0||18e4",
			"Pacific/Niue|-11|b0|0||12e2",
			"Etc/GMT+12|-12|c0|0|",
			"Pacific/Galapagos|-06|60|0||25e3",
			"Etc/GMT+7|-07|70|0|",
			"Pacific/Pitcairn|-08|80|0||56",
			"Pacific/Gambier|-09|90|0||125",
			"Etc/GMT-1|+01|-10|0|",
			"Pacific/Fakaofo|+13|-d0|0||483",
			"Pacific/Kiritimati|+14|-e0|0||51e2",
			"Etc/GMT-2|+02|-20|0|",
			"Etc/UCT|UCT|0|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Astrakhan|+04 +03|-40 -30|010|1N7y0 3rd0",
			"Europe/London|GMT BST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|10e6",
			"Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|67e4",
			"Europe/Kaliningrad|+03 EET|-30 -20|01|1N7z0|44e4",
			"Europe/Volgograd|+04 +03|-40 -30|01|1N7y0|10e5",
			"Europe/Moscow|MSK MSK|-40 -30|01|1N7y0|16e6",
			"Europe/Saratov|+04 +03|-40 -30|010|1N7y0 5810",
			"Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|0101023|1GNB0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Pacific/Honolulu|HST|a0|0||37e4",
			"MET|MET MEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0",
			"Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|+14 +13|-e0 -d0|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|+10 +11|-a0 -b0|01|1NwE0|18e4",
			"Pacific/Fiji|+13 +12|-d0 -c0|01010101010101010101010|1Goe0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0|88e4",
			"Pacific/Guam|ChST|-a0|0||17e4",
			"Pacific/Marquesas|-0930|9u|0||86e2",
			"Pacific/Pago_Pago|SST|b0|0||37e2",
			"Pacific/Norfolk|+1130 +11|-bu -b0|01|1PoCu|25e4",
			"Pacific/Tongatapu|+13 +14|-d0 -e0|010|1S4d0 s00|75e3"
		],
		"links": [
			"Africa/Abidjan|Africa/Accra",
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Bissau",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Monrovia",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Sao_Tome",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|America/Danmarkshavn",
			"Africa/Abidjan|Atlantic/Reykjavik",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Abidjan|Etc/GMT",
			"Africa/Abidjan|Etc/GMT+0",
			"Africa/Abidjan|Etc/GMT-0",
			"Africa/Abidjan|Etc/GMT0",
			"Africa/Abidjan|Etc/Greenwich",
			"Africa/Abidjan|GMT",
			"Africa/Abidjan|GMT+0",
			"Africa/Abidjan|GMT-0",
			"Africa/Abidjan|GMT0",
			"Africa/Abidjan|Greenwich",
			"Africa/Abidjan|Iceland",
			"Africa/Algiers|Africa/Tunis",
			"Africa/Cairo|Egypt",
			"Africa/Casablanca|Africa/El_Aaiun",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Ndjamena",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Juba",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|America/Juneau",
			"America/Anchorage|America/Nome",
			"America/Anchorage|America/Sitka",
			"America/Anchorage|America/Yakutat",
			"America/Anchorage|US/Alaska",
			"America/Campo_Grande|America/Cuiaba",
			"America/Chicago|America/Indiana/Knox",
			"America/Chicago|America/Indiana/Tell_City",
			"America/Chicago|America/Knox_IN",
			"America/Chicago|America/Matamoros",
			"America/Chicago|America/Menominee",
			"America/Chicago|America/North_Dakota/Beulah",
			"America/Chicago|America/North_Dakota/Center",
			"America/Chicago|America/North_Dakota/New_Salem",
			"America/Chicago|America/Rainy_River",
			"America/Chicago|America/Rankin_Inlet",
			"America/Chicago|America/Resolute",
			"America/Chicago|America/Winnipeg",
			"America/Chicago|CST6CDT",
			"America/Chicago|Canada/Central",
			"America/Chicago|US/Central",
			"America/Chicago|US/Indiana-Starke",
			"America/Chihuahua|America/Mazatlan",
			"America/Chihuahua|Mexico/BajaSur",
			"America/Denver|America/Boise",
			"America/Denver|America/Cambridge_Bay",
			"America/Denver|America/Edmonton",
			"America/Denver|America/Inuvik",
			"America/Denver|America/Ojinaga",
			"America/Denver|America/Shiprock",
			"America/Denver|America/Yellowknife",
			"America/Denver|Canada/Mountain",
			"America/Denver|MST7MDT",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Fortaleza|America/Argentina/Buenos_Aires",
			"America/Fortaleza|America/Argentina/Catamarca",
			"America/Fortaleza|America/Argentina/ComodRivadavia",
			"America/Fortaleza|America/Argentina/Cordoba",
			"America/Fortaleza|America/Argentina/Jujuy",
			"America/Fortaleza|America/Argentina/La_Rioja",
			"America/Fortaleza|America/Argentina/Mendoza",
			"America/Fortaleza|America/Argentina/Rio_Gallegos",
			"America/Fortaleza|America/Argentina/Salta",
			"America/Fortaleza|America/Argentina/San_Juan",
			"America/Fortaleza|America/Argentina/San_Luis",
			"America/Fortaleza|America/Argentina/Tucuman",
			"America/Fortaleza|America/Argentina/Ushuaia",
			"America/Fortaleza|America/Belem",
			"America/Fortaleza|America/Buenos_Aires",
			"America/Fortaleza|America/Catamarca",
			"America/Fortaleza|America/Cayenne",
			"America/Fortaleza|America/Cordoba",
			"America/Fortaleza|America/Jujuy",
			"America/Fortaleza|America/Maceio",
			"America/Fortaleza|America/Mendoza",
			"America/Fortaleza|America/Paramaribo",
			"America/Fortaleza|America/Recife",
			"America/Fortaleza|America/Rosario",
			"America/Fortaleza|America/Santarem",
			"America/Fortaleza|Antarctica/Rothera",
			"America/Fortaleza|Atlantic/Stanley",
			"America/Fortaleza|Etc/GMT+3",
			"America/Halifax|America/Glace_Bay",
			"America/Halifax|America/Goose_Bay",
			"America/Halifax|America/Moncton",
			"America/Halifax|America/Thule",
			"America/Halifax|Atlantic/Bermuda",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/La_Paz|America/Boa_Vista",
			"America/La_Paz|America/Guyana",
			"America/La_Paz|America/Manaus",
			"America/La_Paz|America/Porto_Velho",
			"America/La_Paz|Brazil/West",
			"America/La_Paz|Etc/GMT+4",
			"America/Lima|America/Bogota",
			"America/Lima|America/Guayaquil",
			"America/Lima|Etc/GMT+5",
			"America/Los_Angeles|America/Dawson",
			"America/Los_Angeles|America/Ensenada",
			"America/Los_Angeles|America/Santa_Isabel",
			"America/Los_Angeles|America/Tijuana",
			"America/Los_Angeles|America/Vancouver",
			"America/Los_Angeles|America/Whitehorse",
			"America/Los_Angeles|Canada/Pacific",
			"America/Los_Angeles|Canada/Yukon",
			"America/Los_Angeles|Mexico/BajaNorte",
			"America/Los_Angeles|PST8PDT",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Managua|America/Belize",
			"America/Managua|America/Costa_Rica",
			"America/Managua|America/El_Salvador",
			"America/Managua|America/Guatemala",
			"America/Managua|America/Regina",
			"America/Managua|America/Swift_Current",
			"America/Managua|America/Tegucigalpa",
			"America/Managua|Canada/Saskatchewan",
			"America/Mexico_City|America/Bahia_Banderas",
			"America/Mexico_City|America/Merida",
			"America/Mexico_City|America/Monterrey",
			"America/Mexico_City|Mexico/General",
			"America/New_York|America/Detroit",
			"America/New_York|America/Fort_Wayne",
			"America/New_York|America/Indiana/Indianapolis",
			"America/New_York|America/Indiana/Marengo",
			"America/New_York|America/Indiana/Petersburg",
			"America/New_York|America/Indiana/Vevay",
			"America/New_York|America/Indiana/Vincennes",
			"America/New_York|America/Indiana/Winamac",
			"America/New_York|America/Indianapolis",
			"America/New_York|America/Iqaluit",
			"America/New_York|America/Kentucky/Louisville",
			"America/New_York|America/Kentucky/Monticello",
			"America/New_York|America/Louisville",
			"America/New_York|America/Montreal",
			"America/New_York|America/Nassau",
			"America/New_York|America/Nipigon",
			"America/New_York|America/Pangnirtung",
			"America/New_York|America/Thunder_Bay",
			"America/New_York|America/Toronto",
			"America/New_York|Canada/Eastern",
			"America/New_York|EST5EDT",
			"America/New_York|US/East-Indiana",
			"America/New_York|US/Eastern",
			"America/New_York|US/Michigan",
			"America/Noronha|Atlantic/South_Georgia",
			"America/Noronha|Brazil/DeNoronha",
			"America/Noronha|Etc/GMT+2",
			"America/Panama|America/Atikokan",
			"America/Panama|America/Cayman",
			"America/Panama|America/Coral_Harbour",
			"America/Panama|America/Jamaica",
			"America/Panama|EST",
			"America/Panama|Jamaica",
			"America/Phoenix|America/Creston",
			"America/Phoenix|America/Dawson_Creek",
			"America/Phoenix|America/Hermosillo",
			"America/Phoenix|MST",
			"America/Phoenix|US/Arizona",
			"America/Rio_Branco|America/Eirunepe",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Santo_Domingo|America/Anguilla",
			"America/Santo_Domingo|America/Antigua",
			"America/Santo_Domingo|America/Aruba",
			"America/Santo_Domingo|America/Barbados",
			"America/Santo_Domingo|America/Blanc-Sablon",
			"America/Santo_Domingo|America/Curacao",
			"America/Santo_Domingo|America/Dominica",
			"America/Santo_Domingo|America/Grenada",
			"America/Santo_Domingo|America/Guadeloupe",
			"America/Santo_Domingo|America/Kralendijk",
			"America/Santo_Domingo|America/Lower_Princes",
			"America/Santo_Domingo|America/Marigot",
			"America/Santo_Domingo|America/Martinique",
			"America/Santo_Domingo|America/Montserrat",
			"America/Santo_Domingo|America/Port_of_Spain",
			"America/Santo_Domingo|America/Puerto_Rico",
			"America/Santo_Domingo|America/St_Barthelemy",
			"America/Santo_Domingo|America/St_Kitts",
			"America/Santo_Domingo|America/St_Lucia",
			"America/Santo_Domingo|America/St_Thomas",
			"America/Santo_Domingo|America/St_Vincent",
			"America/Santo_Domingo|America/Tortola",
			"America/Santo_Domingo|America/Virgin",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"Antarctica/Palmer|America/Punta_Arenas",
			"Asia/Baghdad|Antarctica/Syowa",
			"Asia/Baghdad|Asia/Aden",
			"Asia/Baghdad|Asia/Bahrain",
			"Asia/Baghdad|Asia/Kuwait",
			"Asia/Baghdad|Asia/Qatar",
			"Asia/Baghdad|Asia/Riyadh",
			"Asia/Baghdad|Etc/GMT-3",
			"Asia/Baghdad|Europe/Minsk",
			"Asia/Bangkok|Asia/Ho_Chi_Minh",
			"Asia/Bangkok|Asia/Novokuznetsk",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Saigon",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Bangkok|Etc/GMT-7",
			"Asia/Bangkok|Indian/Christmas",
			"Asia/Dhaka|Antarctica/Vostok",
			"Asia/Dhaka|Asia/Almaty",
			"Asia/Dhaka|Asia/Bishkek",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dhaka|Asia/Kashgar",
			"Asia/Dhaka|Asia/Qyzylorda",
			"Asia/Dhaka|Asia/Thimbu",
			"Asia/Dhaka|Asia/Thimphu",
			"Asia/Dhaka|Asia/Urumqi",
			"Asia/Dhaka|Etc/GMT-6",
			"Asia/Dhaka|Indian/Chagos",
			"Asia/Dili|Etc/GMT-9",
			"Asia/Dili|Pacific/Palau",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Dubai|Asia/Tbilisi",
			"Asia/Dubai|Asia/Yerevan",
			"Asia/Dubai|Etc/GMT-4",
			"Asia/Dubai|Europe/Samara",
			"Asia/Dubai|Indian/Mahe",
			"Asia/Dubai|Indian/Mauritius",
			"Asia/Dubai|Indian/Reunion",
			"Asia/Gaza|Asia/Hebron",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jakarta|Asia/Pontianak",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kamchatka|Asia/Anadyr",
			"Asia/Kamchatka|Etc/GMT-12",
			"Asia/Kamchatka|Kwajalein",
			"Asia/Kamchatka|Pacific/Funafuti",
			"Asia/Kamchatka|Pacific/Kwajalein",
			"Asia/Kamchatka|Pacific/Majuro",
			"Asia/Kamchatka|Pacific/Nauru",
			"Asia/Kamchatka|Pacific/Tarawa",
			"Asia/Kamchatka|Pacific/Wake",
			"Asia/Kamchatka|Pacific/Wallis",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Manila|Asia/Brunei",
			"Asia/Manila|Asia/Kuala_Lumpur",
			"Asia/Manila|Asia/Kuching",
			"Asia/Manila|Asia/Singapore",
			"Asia/Manila|Etc/GMT-8",
			"Asia/Manila|Singapore",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Rangoon|Indian/Cocos",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|Asia/Macao",
			"Asia/Shanghai|Asia/Macau",
			"Asia/Shanghai|Asia/Taipei",
			"Asia/Shanghai|PRC",
			"Asia/Shanghai|ROC",
			"Asia/Tashkent|Antarctica/Mawson",
			"Asia/Tashkent|Asia/Aqtau",
			"Asia/Tashkent|Asia/Aqtobe",
			"Asia/Tashkent|Asia/Ashgabat",
			"Asia/Tashkent|Asia/Ashkhabad",
			"Asia/Tashkent|Asia/Atyrau",
			"Asia/Tashkent|Asia/Dushanbe",
			"Asia/Tashkent|Asia/Oral",
			"Asia/Tashkent|Asia/Samarkand",
			"Asia/Tashkent|Etc/GMT-5",
			"Asia/Tashkent|Indian/Kerguelen",
			"Asia/Tashkent|Indian/Maldives",
			"Asia/Tehran|Iran",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Choibalsan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Vladivostok|Asia/Ust-Nera",
			"Asia/Yakutsk|Asia/Khandyga",
			"Atlantic/Azores|America/Scoresbysund",
			"Atlantic/Cape_Verde|Etc/GMT+1",
			"Australia/Adelaide|Australia/Broken_Hill",
			"Australia/Adelaide|Australia/South",
			"Australia/Adelaide|Australia/Yancowinna",
			"Australia/Brisbane|Australia/Lindeman",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Darwin|Australia/North",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/Currie",
			"Australia/Sydney|Australia/Hobart",
			"Australia/Sydney|Australia/Melbourne",
			"Australia/Sydney|Australia/NSW",
			"Australia/Sydney|Australia/Tasmania",
			"Australia/Sydney|Australia/Victoria",
			"Etc/UCT|UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Astrakhan|Europe/Ulyanovsk",
			"Europe/Athens|Asia/Nicosia",
			"Europe/Athens|EET",
			"Europe/Athens|Europe/Bucharest",
			"Europe/Athens|Europe/Helsinki",
			"Europe/Athens|Europe/Kiev",
			"Europe/Athens|Europe/Mariehamn",
			"Europe/Athens|Europe/Nicosia",
			"Europe/Athens|Europe/Riga",
			"Europe/Athens|Europe/Sofia",
			"Europe/Athens|Europe/Tallinn",
			"Europe/Athens|Europe/Uzhgorod",
			"Europe/Athens|Europe/Vilnius",
			"Europe/Athens|Europe/Zaporozhye",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Atlantic/Canary",
			"Europe/Lisbon|Atlantic/Faeroe",
			"Europe/Lisbon|Atlantic/Faroe",
			"Europe/Lisbon|Atlantic/Madeira",
			"Europe/Lisbon|Portugal",
			"Europe/Lisbon|WET",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Paris|Africa/Ceuta",
			"Europe/Paris|Arctic/Longyearbyen",
			"Europe/Paris|Atlantic/Jan_Mayen",
			"Europe/Paris|CET",
			"Europe/Paris|Europe/Amsterdam",
			"Europe/Paris|Europe/Andorra",
			"Europe/Paris|Europe/Belgrade",
			"Europe/Paris|Europe/Berlin",
			"Europe/Paris|Europe/Bratislava",
			"Europe/Paris|Europe/Brussels",
			"Europe/Paris|Europe/Budapest",
			"Europe/Paris|Europe/Busingen",
			"Europe/Paris|Europe/Copenhagen",
			"Europe/Paris|Europe/Gibraltar",
			"Europe/Paris|Europe/Ljubljana",
			"Europe/Paris|Europe/Luxembourg",
			"Europe/Paris|Europe/Madrid",
			"Europe/Paris|Europe/Malta",
			"Europe/Paris|Europe/Monaco",
			"Europe/Paris|Europe/Oslo",
			"Europe/Paris|Europe/Podgorica",
			"Europe/Paris|Europe/Prague",
			"Europe/Paris|Europe/Rome",
			"Europe/Paris|Europe/San_Marino",
			"Europe/Paris|Europe/Sarajevo",
			"Europe/Paris|Europe/Skopje",
			"Europe/Paris|Europe/Stockholm",
			"Europe/Paris|Europe/Tirane",
			"Europe/Paris|Europe/Vaduz",
			"Europe/Paris|Europe/Vatican",
			"Europe/Paris|Europe/Vienna",
			"Europe/Paris|Europe/Warsaw",
			"Europe/Paris|Europe/Zagreb",
			"Europe/Paris|Europe/Zurich",
			"Europe/Paris|Poland",
			"Europe/Volgograd|Europe/Kirov",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Fakaofo|Etc/GMT-13",
			"Pacific/Fakaofo|Pacific/Enderbury",
			"Pacific/Galapagos|Etc/GMT+6",
			"Pacific/Gambier|Etc/GMT+9",
			"Pacific/Guadalcanal|Antarctica/Macquarie",
			"Pacific/Guadalcanal|Etc/GMT-11",
			"Pacific/Guadalcanal|Pacific/Efate",
			"Pacific/Guadalcanal|Pacific/Kosrae",
			"Pacific/Guadalcanal|Pacific/Noumea",
			"Pacific/Guadalcanal|Pacific/Pohnpei",
			"Pacific/Guadalcanal|Pacific/Ponape",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|HST",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kiritimati|Etc/GMT-14",
			"Pacific/Niue|Etc/GMT+11",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Pitcairn|Etc/GMT+8",
			"Pacific/Port_Moresby|Antarctica/DumontDUrville",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Port_Moresby|Pacific/Chuuk",
			"Pacific/Port_Moresby|Pacific/Truk",
			"Pacific/Port_Moresby|Pacific/Yap",
			"Pacific/Tahiti|Etc/GMT+10",
			"Pacific/Tahiti|Pacific/Rarotonga"
		]
	});


	return moment;
}));
define("discourse/plugins/discourse-events/discourse/components/add-event-controls", ["exports", "discourse/lib/show-modal", "../lib/date-utilities", "discourse-common/utils/decorators", "@ember/component"], function (_exports, _showModal, _dateUtilities, _decorators, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)('noText'), _dec2 = (0, _decorators.default)('event'), _dec3 = (0, _decorators.default)('category', 'noText'), (_obj = {
    classNames: ['event-label'],
    didInsertElement: function didInsertElement() {
      $('.title-and-category').toggleClass('event-add-no-text', this.get("iconOnly"));
    },
    valueClasses: function valueClasses(noText) {
      var classes = "add-event";
      if (noText) classes += " btn-primary";
      return classes;
    },
    valueLabel: function valueLabel(event) {
      return (0, _dateUtilities.eventLabel)(event, {
        noText: this.get('noText'),
        useEventTimezone: true,
        showRsvp: true,
        siteSettings: this.siteSettings
      });
    },
    iconOnly: function iconOnly(category, noText) {
      return noText || this.siteSettings.events_event_label_no_text || Boolean(category && category.get('custom_fields.events_event_label_no_text'));
    },
    actions: {
      showAddEvent: function showAddEvent() {
        var _this = this;

        var controller = (0, _showModal.default)('add-event', {
          model: {
            bufferedEvent: this.event,
            event: this.event,
            update: function update(event) {
              _this.set('event', event);
            }
          }
        });
      },
      removeEvent: function removeEvent() {
        this.set('event', null);
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "valueClasses", [_dec], Object.getOwnPropertyDescriptor(_obj, "valueClasses"), _obj), _applyDecoratedDescriptor(_obj, "valueLabel", [_dec2], Object.getOwnPropertyDescriptor(_obj, "valueLabel"), _obj), _applyDecoratedDescriptor(_obj, "iconOnly", [_dec3], Object.getOwnPropertyDescriptor(_obj, "iconOnly"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/add-to-calendar", ["exports", "../lib/date-utilities", "discourse-common/utils/decorators", "@ember/runloop", "@ember/component"], function (_exports, _dateUtilities, _decorators, _runloop, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)('topic.event'), (_obj = {
    expanded: false,
    classNames: 'add-to-calendar',
    didInsertElement: function didInsertElement() {
      $(document).on('click', (0, _runloop.bind)(this, this.outsideClick));
    },
    willDestroyElement: function willDestroyElement() {
      $(document).off('click', (0, _runloop.bind)(this, this.outsideClick));
    },
    outsideClick: function outsideClick(e) {
      if (!this.isDestroying && !$(e.target).closest('.add-to-calendar').length) {
        this.set('expanded', false);
      }
    },
    calendarUris: function calendarUris() {
      var topic = this.get('topic');
      var params = {
        event: topic.event,
        title: topic.title,
        url: window.location.hostname + topic.get('url')
      };

      if (topic.location && topic.location.geo_location) {
        params['location'] = topic.location.geo_location.address;
      }

      return [{
        uri: (0, _dateUtilities.googleUri)(params),
        label: 'google'
      }, {
        uri: (0, _dateUtilities.icsUri)(params),
        label: 'ics'
      }];
    },
    actions: {
      expand: function expand() {
        this.toggleProperty('expanded');
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "calendarUris", [_dec], Object.getOwnPropertyDescriptor(_obj, "calendarUris"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/event-form", ["exports", "@ember/component", "discourse-common/utils/decorators", "@ember/runloop", "../lib/date-utilities"], function (_exports, _component, _decorators, _runloop, _dateUtilities) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.observes)('startDate', 'startTime', 'endDate', 'endTime', 'endEnabled', 'allDay', 'timezone', 'rsvpEnabled', 'goingMax', 'usersGoing'), _dec2 = (0, _decorators.default)(), _dec3 = (0, _decorators.default)('endEnabled'), (_obj = {
    classNames: 'event-form',
    endEnabled: false,
    allDay: false,
    showTimezone: false,
    didInsertElement: function didInsertElement() {
      var props = (0, _dateUtilities.setupEventForm)(this.event, {
        siteSettings: this.siteSettings
      });
      this.setProperties(props);
      this.setupTimePicker('start');
      this.setupTimePicker('end');
    },
    eventValid: function eventValid(event) {
      return !event || !event.end || moment(event.end).isSameOrAfter(event.start);
    },
    eventUpdated: function eventUpdated() {
      var event = (0, _dateUtilities.compileEvent)({
        startDate: this.startDate,
        startTime: this.startTime,
        endDate: this.endDate,
        endTime: this.endTime,
        endEnabled: this.endEnabled,
        allDay: this.allDay,
        timezone: this.timezone,
        rsvpEnabled: this.rsvpEnabled,
        goingMax: this.goingMax,
        usersGoing: this.usersGoing
      });
      this.updateEvent(event, this.eventValid(event));
    },
    setupTimePicker: function setupTimePicker(type) {
      var _this = this;

      var time = this.get("".concat(type, "Time"));
      (0, _runloop.later)(this, function () {
        (0, _runloop.scheduleOnce)('afterRender', _this, function () {
          var $timePicker = $("#".concat(type, "-time-picker"));
          $timePicker.timepicker({
            timeFormat: _this.siteSettings.events_event_timepicker_format
          });
          $timePicker.timepicker('setTime', time);
          $timePicker.change(function () {
            _this.set("".concat(type, "Time"), $timePicker.timepicker('getTime'));
          });
        });
      });
    },
    timezones: function timezones() {
      var _this2 = this;

      var eventTimezones = this.get('eventTimezones') || this.site.event_timezones;
      return eventTimezones.map(function (tz) {
        return {
          value: tz.value,
          name: (0, _dateUtilities.timezoneLabel)(tz.value, {
            siteSettings: _this2.siteSettings
          })
        };
      });
    },
    endClass: function endClass(endEnabled) {
      return endEnabled ? '' : 'disabled';
    },
    actions: {
      toggleEndEnabled: function toggleEndEnabled(value) {
        this.set('endEnabled', value);

        if (value) {
          if (!this.endDate) {
            this.set('endDate', this.startDate);
          }

          if (!this.allDay) {
            if (!this.endTime) {
              this.set('endTime', this.startTime);
            }

            this.setupTimePicker('end');
          }
        }
      },
      toggleAllDay: function toggleAllDay(value) {
        this.set('allDay', value);

        if (!value) {
          var start = (0, _dateUtilities.nextInterval)();
          this.set('startTime', start.format(_dateUtilities.formTimeFormat));
          this.setupTimePicker('start');

          if (this.endEnabled) {
            var end = moment(start).add(1, 'hours');
            this.set('endTime', end.format(_dateUtilities.formTimeFormat));
            this.setupTimePicker('end');
          }
        }
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "eventUpdated", [_dec], Object.getOwnPropertyDescriptor(_obj, "eventUpdated"), _obj), _applyDecoratedDescriptor(_obj, "timezones", [_dec2], Object.getOwnPropertyDescriptor(_obj, "timezones"), _obj), _applyDecoratedDescriptor(_obj, "endClass", [_dec3], Object.getOwnPropertyDescriptor(_obj, "endClass"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/event-rsvp", ["exports", "discourse/lib/ajax-error", "discourse-common/utils/decorators", "discourse/lib/show-modal", "discourse/lib/ajax", "@ember/component", "@ember/object/computed", "I18n"], function (_exports, _ajaxError, _decorators, _showModal, _ajax, _component, _computed, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)('currentUser', 'topic.event.going'), _dec2 = (0, _decorators.default)('topic.event.going'), _dec3 = (0, _decorators.default)('userGoing'), _dec4 = (0, _decorators.default)('currentUser', 'eventFull'), _dec5 = (0, _decorators.default)('goingTotal', 'topic.event.going_max'), _dec6 = (0, _decorators.default)('hasMax', 'eventFull'), (_obj = {
    classNames: 'event-rsvp',
    goingSaving: false,
    userGoing: function userGoing(user, eventGoing) {
      return eventGoing && eventGoing.indexOf(user.username) > -1;
    },
    goingTotal: function goingTotal(eventGoing) {
      if (eventGoing) {
        return eventGoing.length;
      } else {
        return 0;
      }
    },
    goingClasses: function goingClasses(userGoing) {
      return userGoing ? 'btn-primary' : '';
    },
    canGo: function canGo(currentUser, eventFull) {
      return currentUser && !eventFull;
    },
    hasGuests: (0, _computed.gt)('goingTotal', 0),
    hasMax: (0, _computed.notEmpty)('topic.event.going_max'),
    spotsLeft: function spotsLeft(goingTotal, goingMax) {
      return Number(goingMax) - Number(goingTotal);
    },
    eventFull: (0, _computed.equal)('spotsLeft', 0),
    goingMessage: function goingMessage(hasMax, full) {
      if (hasMax) {
        if (full) {
          return _I18n.default.t('event_rsvp.going.max_reached');
        } else {
          var spotsLeft = this.get('spotsLeft');

          if (spotsLeft === 1) {
            return _I18n.default.t('event_rsvp.going.one_spot_left');
          } else {
            return _I18n.default.t('event_rsvp.going.x_spots_left', {
              spotsLeft: spotsLeft
            });
          }
        }
      }

      return false;
    },
    updateTopic: function updateTopic(userName, action, type) {
      var existing = this.get("topic.event.".concat(type));
      var list = existing ? existing : [];

      if (action === 'add') {
        list.push(userName);
      } else {
        list.splice(list.indexOf(userName), 1);
      }

      this.set("topic.event.".concat(type), list);
      this.notifyPropertyChange("topic.event.".concat(type));
    },
    save: function save(user, action, type) {
      var _this = this;

      this.set("".concat(type, "Saving"), true);
      (0, _ajax.ajax)("/calendar-events/rsvp/".concat(action), {
        type: 'POST',
        data: {
          topic_id: this.get('topic.id'),
          type: type,
          usernames: [user.username]
        }
      }).then(function (result) {
        if (result.success) {
          _this.updateTopic(user.username, action, type);
        }
      }).catch(_ajaxError.popupAjaxError).finally(function () {
        _this.set("".concat(type, "Saving"), false);
      });
    },
    actions: {
      going: function going() {
        var currentUser = this.get('currentUser');
        var userGoing = this.get('userGoing');
        var action = userGoing ? 'remove' : 'add';
        this.save(currentUser, action, 'going');
      },
      openModal: function openModal() {
        var topic = this.get('topic');
        var controller = (0, _showModal.default)('event-rsvp', {
          model: {
            topic: topic
          }
        });
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "userGoing", [_dec], Object.getOwnPropertyDescriptor(_obj, "userGoing"), _obj), _applyDecoratedDescriptor(_obj, "goingTotal", [_dec2], Object.getOwnPropertyDescriptor(_obj, "goingTotal"), _obj), _applyDecoratedDescriptor(_obj, "goingClasses", [_dec3], Object.getOwnPropertyDescriptor(_obj, "goingClasses"), _obj), _applyDecoratedDescriptor(_obj, "canGo", [_dec4], Object.getOwnPropertyDescriptor(_obj, "canGo"), _obj), _applyDecoratedDescriptor(_obj, "spotsLeft", [_dec5], Object.getOwnPropertyDescriptor(_obj, "spotsLeft"), _obj), _applyDecoratedDescriptor(_obj, "goingMessage", [_dec6], Object.getOwnPropertyDescriptor(_obj, "goingMessage"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/event-webcal-keys", ["exports", "@ember/component", "discourse/lib/ajax", "discourse/lib/ajax-error"], function (_exports, _component, _ajax, _ajaxError) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var KEY_ENDPOINT = "/calendar-events/api_keys.json";

  var _default = _component.default.extend({
    actions: {
      show: function show() {
        var _this = this;

        (0, _ajax.ajax)(KEY_ENDPOINT, {
          type: 'GET'
        }).then(function (result) {
          _this.set('apiKey', result['api_keys'][0]['key']);

          _this.set('clientID', result['api_keys'][0]['client_id']);
        }).catch(_ajaxError.popupAjaxError);
      }
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/events-calendar-body", ["exports", "discourse-common/utils/decorators", "../lib/date-utilities", "@ember/component", "I18n"], function (_exports, _decorators, _dateUtilities, _component, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _obj;

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.on)('init'), _dec2 = (0, _decorators.default)('responsive'), _dec3 = (0, _decorators.observes)('currentMonth'), (_obj = {
    classNames: 'events-calendar-body',
    expandedDate: 0.0,
    setup: function setup() {
      this._super();

      moment.locale(_I18n.default.locale);
    },
    weekdays: function weekdays(responsive) {
      var data = moment.localeData();
      var weekdays = $.extend([], responsive ? data.weekdaysMin() : data.weekdays());
      var firstDay = (0, _dateUtilities.firstDayOfWeek)();
      var beforeFirst = weekdays.splice(0, firstDay);
      weekdays.push.apply(weekdays, _toConsumableArray(beforeFirst));
      return weekdays;
    },
    resetExpandedDate: function resetExpandedDate() {
      this.set('expandedDate', null);
    },
    actions: {
      selectDate: function selectDate(date, month) {
        this.sendAction('selectDate', date, month);
      },
      setExpandedDate: function setExpandedDate(date) {
        var month = this.get('currentMonth');
        this.set('expandedDate', month + '.' + date);
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "setup", [_dec], Object.getOwnPropertyDescriptor(_obj, "setup"), _obj), _applyDecoratedDescriptor(_obj, "weekdays", [_dec2], Object.getOwnPropertyDescriptor(_obj, "weekdays"), _obj), _applyDecoratedDescriptor(_obj, "resetExpandedDate", [_dec3], Object.getOwnPropertyDescriptor(_obj, "resetExpandedDate"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/events-calendar-card", ["exports", "discourse/lib/url", "discourse/lib/text", "discourse-common/utils/decorators", "@ember/runloop", "@ember/component"], function (_exports, _url, _text, _decorators, _runloop, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.on)('init'), (_obj = {
    classNames: 'events-calendar-card',
    setup: function setup() {
      var _this = this;

      var excerpt = this.get('topic.excerpt');
      var title = this.get('topic.title');
      (0, _text.cookAsync)(excerpt).then(function (cooked) {
        return _this.set('cookedExcerpt', cooked);
      });
      (0, _text.cookAsync)(title).then(function (cooked) {
        return _this.set('cookedTitle', cooked);
      });
    },
    didInsertElement: function didInsertElement() {
      var _this2 = this;

      this.set('clickHandler', (0, _runloop.bind)(this, this.documentClick));
      (0, _runloop.next)(function () {
        return $(document).on('mousedown', _this2.get('clickHandler'));
      });
      (0, _runloop.scheduleOnce)('afterRender', function () {
        var offsetLeft = _this2.$().closest('.day').offset().left;

        var offsetTop = _this2.$().closest('.day').offset().top;

        var windowWidth = $(window).width();
        var windowHeight = $(window).height();
        var css;

        if (offsetLeft > windowWidth / 2) {
          css = {
            left: "-390px",
            right: "initial"
          };
        } else {
          css = {
            right: "-390px",
            left: "initial"
          };
        }

        if (offsetTop > windowHeight / 2) {
          css = $.extend(css, {
            bottom: "-15px",
            top: "initial"
          });
        } else {
          css = $.extend(css, {
            top: "-15px",
            bottom: "initial"
          });
        }

        _this2.$().css(css);
      });
    },
    willDestroyElement: function willDestroyElement() {
      $(document).off('mousedown', this.get('clickHandler'));
    },
    documentClick: function documentClick(event) {
      var $element = this.$();
      var $target = $(event.target);

      if (!$target.closest($element).length) {
        this.clickOutside();
      }
    },
    clickOutside: function clickOutside() {
      this.close();
    },
    close: function close() {
      this.sendAction('selectEvent');
    },
    actions: {
      goToTopic: function goToTopic() {
        var url = this.get('topic.url');

        _url.default.routeTo(url);
      },
      close: function close() {
        this.close();
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "setup", [_dec], Object.getOwnPropertyDescriptor(_obj, "setup"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/events-calendar-day", ["exports", "discourse-common/utils/decorators", "../lib/date-utilities", "@ember/object/computed", "@ember/runloop", "@ember/component", "@ember/template"], function (_exports, _decorators, _dateUtilities, _computed, _runloop, _component, _template) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var MAX_EVENTS = 4;

  var _default = _component.default.extend((_dec = (0, _decorators.default)('date', 'month', 'expandedDate'), _dec2 = (0, _decorators.default)('month', 'currentMonth'), _dec3 = (0, _decorators.on)('init'), _dec4 = (0, _decorators.observes)('expanded'), _dec5 = (0, _decorators.default)('day', 'topics.[]', 'expanded', 'rowIndex'), _dec6 = (0, _decorators.default)('index'), _dec7 = (0, _decorators.default)('index'), _dec8 = (0, _decorators.default)('index'), _dec9 = (0, _decorators.default)('day', 'currentDate', 'currentMonth', 'expanded', 'responsive'), _dec10 = (0, _decorators.default)('expanded'), (_obj = {
    classNameBindings: [':day', 'classes', 'differentMonth'],
    hidden: 0,
    hasHidden: (0, _computed.gt)('hidden', 0),
    expanded: function expanded(date, month, expandedDate) {
      return "".concat(month, ".").concat(date) === expandedDate;
    },
    differentMonth: function differentMonth(month, currentMonth) {
      return month !== currentMonth;
    },
    setEvents: function setEvents() {
      var expanded = this.get('expanded');
      var allEvents = this.get('allEvents');
      var events = $.extend([], allEvents);

      if (events.length && !expanded) {
        var hidden = events.splice(MAX_EVENTS);

        if (hidden.length) {
          this.set('hidden', hidden.length);
        }
      } else {
        this.set('hidden', 0);
      }

      this.set("events", events);
    },
    allEvents: function allEvents(day, topics, expanded, rowIndex) {
      return (0, _dateUtilities.eventsForDay)(day, topics, {
        rowIndex: rowIndex,
        expanded: expanded,
        siteSettings: this.siteSettings
      });
    },
    rowIndex: function rowIndex(index) {
      return index % 7;
    },
    didInsertElement: function didInsertElement() {
      this.set('clickHandler', (0, _runloop.bind)(this, this.documentClick));
      $(document).on('click', this.get('clickHandler'));
    },
    willDestroyElement: function willDestroyElement() {
      $(document).off('click', this.get('clickHandler'));
    },
    documentClick: function documentClick(event) {
      var $element = this.$();
      var $target = $(event.target);

      if (!$target.closest($element).length) {
        this.clickOutside();
      }
    },
    clickOutside: function clickOutside() {
      if (this.get('expanded')) {
        this.get('setExpandedDate')(null);
      }
    },
    click: function click() {
      var canSelectDate = this.get('canSelectDate');

      if (canSelectDate) {
        var date = this.get('date');
        var month = this.get('month');
        this.sendAction('selectDate', date, month);
      }
    },
    date: function date() {
      var day = this.get('day');
      return day.date();
    },
    month: function month() {
      var day = this.get('day');
      return day.month();
    },
    classes: function classes(day, currentDate, currentMonth, expanded, responsive) {
      var classes = '';

      if (day.isSame(moment(), "day")) {
        classes += 'today ';
      }

      if (responsive && day.isSame(moment().month(currentMonth).date(currentDate), "day")) {
        classes += 'selected ';
      }

      if (expanded) {
        classes += 'expanded';
      }

      return classes;
    },
    containerStyle: function containerStyle(expanded) {
      var style = '';

      if (expanded) {
        var offsetLeft = this.$().offset().left;
        var offsetTop = this.$().offset().top;
        var windowWidth = $(window).width();
        var windowHeight = $(window).height();

        if (offsetLeft > windowWidth / 2) {
          style += 'right:0;';
        } else {
          style += 'left:0;';
        }

        if (offsetTop > windowHeight / 2) {
          style += 'bottom:0;';
        } else {
          style += 'top:0;';
        }
      }

      return (0, _template.htmlSafe)(style);
    }
  }, (_applyDecoratedDescriptor(_obj, "expanded", [_dec], Object.getOwnPropertyDescriptor(_obj, "expanded"), _obj), _applyDecoratedDescriptor(_obj, "differentMonth", [_dec2], Object.getOwnPropertyDescriptor(_obj, "differentMonth"), _obj), _applyDecoratedDescriptor(_obj, "setEvents", [_dec3, _dec4], Object.getOwnPropertyDescriptor(_obj, "setEvents"), _obj), _applyDecoratedDescriptor(_obj, "allEvents", [_dec5], Object.getOwnPropertyDescriptor(_obj, "allEvents"), _obj), _applyDecoratedDescriptor(_obj, "rowIndex", [_dec6], Object.getOwnPropertyDescriptor(_obj, "rowIndex"), _obj), _applyDecoratedDescriptor(_obj, "date", [_dec7], Object.getOwnPropertyDescriptor(_obj, "date"), _obj), _applyDecoratedDescriptor(_obj, "month", [_dec8], Object.getOwnPropertyDescriptor(_obj, "month"), _obj), _applyDecoratedDescriptor(_obj, "classes", [_dec9], Object.getOwnPropertyDescriptor(_obj, "classes"), _obj), _applyDecoratedDescriptor(_obj, "containerStyle", [_dec10], Object.getOwnPropertyDescriptor(_obj, "containerStyle"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/events-calendar-event", ["exports", "discourse/lib/url", "@ember/component"], function (_exports, _url, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _component.default.extend({
    tagName: 'li',
    actions: {
      selectEvent: function selectEvent(url) {
        var responsive = this.get('responsive');

        if (responsive) {
          _url.default.routeTo(url);
        } else {
          this.toggleProperty('showEventCard');
        }
      }
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/events-calendar-events", ["exports", "@ember/component"], function (_exports, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _component.default.extend({
    tagName: 'ul',
    classNames: 'events-calendar-events'
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/events-calendar-subscription-row", ["exports", "select-kit/components/dropdown-select-box/dropdown-select-box-row", "discourse/lib/copy-text", "@ember/runloop"], function (_exports, _dropdownSelectBoxRow, _copyText, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _dropdownSelectBoxRow.default.extend({
    layoutName: "discourse/templates/components/events-calendar-subscription-row",
    classNames: "events-calendar-subscription-row",
    click: function click() {
      var _this = this;

      var $copyRange = $('<p id="copy-range"></p>');
      $copyRange.html(this.item.id);
      $(document.body).append($copyRange);

      if ((0, _copyText.default)(this.item.id, $copyRange[0])) {
        this.set("copiedUrl", true);
        (0, _runloop.later)(function () {
          return _this.set("copiedUrl", false);
        }, 2000);
      }

      $copyRange.remove();
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/events-calendar-subscription", ["exports", "select-kit/components/dropdown-select-box", "discourse-common/utils/decorators", "discourse/models/category", "I18n", "discourse-common/lib/get-url"], function (_exports, _dropdownSelectBox, _decorators, _category, _I18n, _getUrl) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _dropdownSelectBox.default.extend((_dec = (0, _decorators.default)(), (_obj = {
    classNames: ["events-calendar-subscription"],
    modifyComponentForRow: function modifyComponentForRow() {
      return "events-calendar-subscription-row";
    },
    getDomain: function getDomain() {
      return location.hostname + (location.port ? ':' + location.port : '');
    },
    content: function content() {
      var path = this.category ? "/c/".concat(_category.default.slugFor(this.category), "/l") : '';
      var url = this.getDomain() + (0, _getUrl.default)(path);
      var timeZone = moment.tz.guess();
      return [{
        id: "webcal://".concat(url, "/calendar.ics?time_zone=").concat(timeZone),
        name: _I18n.default.t('events_calendar.ical')
      }, {
        id: "".concat(url, "/calendar.rss?time_zone=").concat(timeZone),
        name: _I18n.default.t('events_calendar.rss')
      }];
    },
    actions: {
      onSelect: function onSelect() {}
    }
  }, (_applyDecoratedDescriptor(_obj, "content", [_dec], Object.getOwnPropertyDescriptor(_obj, "content"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/events-calendar", ["exports", "discourse-common/utils/decorators", "../lib/date-utilities", "@ember/object/computed", "discourse/models/category", "discourse/lib/ajax", "@ember/component", "@ember/runloop", "@ember/service", "I18n"], function (_exports, _decorators, _dateUtilities, _computed, _category, _ajax, _component, _runloop, _service, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var RESPONSIVE_BREAKPOINT = 800;
  var YEARS = [moment().subtract(1, 'year').year(), moment().year(), moment().add(1, 'year').year()];
  var KEY_ENDPOINT = "/calendar-events/api_keys.json";

  var _default = _component.default.extend((_dec = (0, _decorators.on)('init'), _dec2 = (0, _decorators.default)('siteSettings.login_required', 'category.read_restricted'), _dec3 = (0, _decorators.on)('willDestroy'), _dec4 = (0, _decorators.default)('responsive'), _dec5 = (0, _decorators.default)('currentDate', 'currentMonth', 'currentYear', 'topics.[]'), _dec6 = (0, _decorators.default)('currentMonth', 'currentYear'), _dec7 = (0, _decorators.default)('category'), _dec8 = (0, _decorators.observes)('month', 'year'), (_obj = {
    classNameBindings: [':events-calendar', 'responsive'],
    showEvents: (0, _computed.not)('eventsBelow'),
    canSelectDate: (0, _computed.alias)('eventsBelow'),
    routing: (0, _service.inject)('-routing'),
    queryParams: (0, _computed.alias)('routing.router.currentState.routerJsState.fullQueryParams'),
    years: YEARS.map(function (y) {
      return {
        id: y,
        name: y
      };
    }),
    layoutName: 'components/events-calendar',
    setup: function setup() {
      var _this = this;

      this._super();

      moment.locale(_I18n.default.locale);
      (0, _runloop.scheduleOnce)('afterRender', function () {
        _this.handleResize();

        $(window).on('resize', (0, _runloop.bind)(_this, _this.handleResize));
        $('body').addClass('calendar');
      });
      var currentDate = moment().date();
      var currentMonth = moment().month();
      var currentYear = moment().year(); // get month and year from the date in middle of the event range

      var initialDateRange = this.get('initialDateRange');
      var queryParams = this.get('queryParams');
      var dateRange = {};
      if (initialDateRange) dateRange = initialDateRange;
      if (queryParams.start) dateRange.start = queryParams.start;
      if (queryParams.end) dateRange.end = queryParams.end;

      if (dateRange.start && dateRange.end) {
        var start = moment(dateRange.start);
        var end = moment(dateRange.end);
        var diff = Math.abs(start.diff(end, "days"));
        var middleDay = start.add(diff / 2, 'days');
        currentMonth = middleDay.month();
        currentYear = middleDay.year();
      }

      var month = currentMonth;
      var year = currentYear;
      this.setProperties({
        currentDate: currentDate,
        currentMonth: currentMonth,
        currentYear: currentYear,
        month: month,
        year: year
      });
    },
    showNotice: function showNotice(loginRequired, categoryRestricted) {
      return loginRequired || categoryRestricted;
    },
    teardown: function teardown() {
      $(window).off('resize', (0, _runloop.bind)(this, this.handleResize));
      $('body').removeClass('calendar');
    },
    handleResize: function handleResize() {
      if (this._state === 'destroying') return;
      this.set("responsiveBreak", $(window).width() < RESPONSIVE_BREAKPOINT);
    },
    forceResponsive: false,
    responsive: (0, _computed.or)('forceResponsive', 'responsiveBreak', 'site.mobileView'),
    showFullTitle: (0, _computed.not)('responsive'),
    eventsBelow: (0, _computed.alias)('responsive'),
    todayLabel: function todayLabel(responsive) {
      return responsive ? null : 'events_calendar.today';
    },
    months: function months() {
      return moment.localeData().months().map(function (m, i) {
        return {
          id: i,
          name: m
        };
      });
    },
    dateEvents: function dateEvents(currentDate, currentMonth, currentYear, topics) {
      var day = moment().year(currentYear).month(currentMonth);
      return (0, _dateUtilities.eventsForDay)(day.date(currentDate), topics, {
        dateEvents: true,
        siteSettings: this.siteSettings
      });
    },
    days: function days(currentMonth, currentYear) {
      var _calendarDays = (0, _dateUtilities.calendarDays)(currentMonth, currentYear),
          start = _calendarDays.start,
          end = _calendarDays.end;

      var days = [];

      for (var day = moment(start); day.isBefore(end); day.add(1, 'days')) {
        days.push(moment().year(day.year()).month(day.month()).date(day.date()));
      }

      return days;
    },
    showSubscription: function showSubscription(category) {
      return true; // !category || !category.read_restricted;
    },
    transitionToMonth: function transitionToMonth(month, year) {
      var _this2 = this;

      var _calendarRange = (0, _dateUtilities.calendarRange)(month, year),
          start = _calendarRange.start,
          end = _calendarRange.end;

      var router = this.get('routing.router');
      if (this.get('loading')) return;
      this.set('loading', true);
      return router.transitionTo({
        queryParams: {
          start: start,
          end: end
        }
      }).then(function () {
        var category = _this2.get('category');

        var filter = '';

        if (category) {
          filter += "c/".concat(_category.default.slugFor(category), "/l/");
        }

        filter += 'calendar';

        _this2.store.findFiltered('topicList', {
          filter: filter,
          params: {
            start: start,
            end: end
          }
        }).then(function (list) {
          _this2.setProperties({
            topics: list.topics,
            currentMonth: month,
            currentYear: year,
            loading: false
          });
        });
      });
    },
    getNewTopics: function getNewTopics() {
      var currentMonth = this.get('currentMonth');
      var currentYear = this.get('currentYear');
      var month = this.get('month');
      var year = this.get('year');

      if (currentMonth !== month || currentYear !== year) {
        this.transitionToMonth(month, year);
      }
    },
    actions: {
      selectDate: function selectDate(selectedDate, selectedMonth) {
        var month = this.get('month');

        if (month !== selectedMonth) {
          this.set('month', selectedMonth);
        }

        this.set('currentDate', selectedDate);
      },
      today: function today() {
        this.setProperties({
          month: moment().month(),
          year: moment().year(),
          currentDate: moment().date()
        });
      },
      monthPrevious: function monthPrevious() {
        var currentMonth = this.get('currentMonth');
        var year = this.get('currentYear');
        var month;

        if (currentMonth === 0) {
          month = 11;
          year = year - 1;
        } else {
          month = currentMonth - 1;
        }

        this.setProperties({
          month: month,
          year: year
        });
      },
      monthNext: function monthNext() {
        var currentMonth = this.get('currentMonth');
        var year = this.get('currentYear');
        var month;

        if (currentMonth === 11) {
          month = 0;
          year = year + 1;
        } else {
          month = currentMonth + 1;
        }

        this.setProperties({
          month: month,
          year: year
        });
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "setup", [_dec], Object.getOwnPropertyDescriptor(_obj, "setup"), _obj), _applyDecoratedDescriptor(_obj, "showNotice", [_dec2], Object.getOwnPropertyDescriptor(_obj, "showNotice"), _obj), _applyDecoratedDescriptor(_obj, "teardown", [_dec3], Object.getOwnPropertyDescriptor(_obj, "teardown"), _obj), _applyDecoratedDescriptor(_obj, "todayLabel", [_dec4], Object.getOwnPropertyDescriptor(_obj, "todayLabel"), _obj), _applyDecoratedDescriptor(_obj, "months", [_decorators.default], Object.getOwnPropertyDescriptor(_obj, "months"), _obj), _applyDecoratedDescriptor(_obj, "dateEvents", [_dec5], Object.getOwnPropertyDescriptor(_obj, "dateEvents"), _obj), _applyDecoratedDescriptor(_obj, "days", [_dec6], Object.getOwnPropertyDescriptor(_obj, "days"), _obj), _applyDecoratedDescriptor(_obj, "showSubscription", [_dec7], Object.getOwnPropertyDescriptor(_obj, "showSubscription"), _obj), _applyDecoratedDescriptor(_obj, "getNewTopics", [_dec8], Object.getOwnPropertyDescriptor(_obj, "getNewTopics"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/components/events-date-picker", ["exports", "discourse/components/date-picker", "discourse-common/utils/decorators", "discourse/lib/load-script", "../lib/date-utilities", "@ember/runloop", "I18n", "discourse-common/lib/object"], function (_exports, _datePicker, _decorators, _loadScript, _dateUtilities, _runloop, _I18n, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _datePicker.default.extend((_dec = (0, _decorators.on)("didInsertElement"), (_obj = {
    layoutName: "components/date-picker",
    _loadDatePicker: function _loadDatePicker() {
      var _this = this;

      var input = this.$(".date-picker")[0];
      var container = $("#" + this.get("containerId"))[0];
      (0, _loadScript.default)("/javascripts/pikaday.js").then(function () {
        (0, _runloop.next)(function () {
          var default_opts = {
            field: input,
            container: container || _this.$()[0],
            bound: container === undefined,
            format: "YYYY-MM-DD",
            firstDay: (0, _dateUtilities.firstDayOfWeek)(),
            i18n: {
              previousMonth: _I18n.default.t("dates.previous_month"),
              nextMonth: _I18n.default.t("dates.next_month"),
              months: moment.months(),
              weekdays: moment.weekdays(),
              weekdaysShort: moment.weekdaysShort()
            },
            onSelect: function onSelect(date) {
              var formattedDate = moment(date).format("YYYY-MM-DD");

              if (_this.attrs.onSelect) {
                _this.attrs.onSelect(formattedDate);
              }

              if (!_this.element || _this.isDestroying || _this.isDestroyed) return;

              _this.set("value", formattedDate);
            }
          };
          _this._picker = new Pikaday((0, _object.deepMerge)(default_opts, _this._opts()));
        });
      });
    }
  }, (_applyDecoratedDescriptor(_obj, "_loadDatePicker", [_dec], Object.getOwnPropertyDescriptor(_obj, "_loadDatePicker"), _obj)), _obj)));

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/discourse/connectors/category-custom-settings/enable-events"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"h3\",true],[8],[1,[28,\"i18n\",[\"category.events_setting_heading\"],null],false],[9],[0,\"\\n\"],[7,\"section\",true],[10,\"class\",\"field\"],[8],[0,\"\\n  \"],[7,\"label\",true],[8],[0,\"\\n    \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"eventsEnabled\"]]]]],false],[0,\"\\n    \"],[1,[28,\"i18n\",[\"category.enable_events\"],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"section\",true],[10,\"class\",\"field min-trust\"],[8],[0,\"\\n  \"],[7,\"label\",true],[8],[0,\"\\n    \"],[1,[28,\"i18n\",[\"category.events_min_trust_to_create\"],null],false],[0,\"\\n    \"],[1,[28,\"input\",null,[[\"type\",\"value\"],[\"number\",[24,[\"category\",\"custom_fields\",\"events_min_trust_to_create\"]]]]],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"section\",true],[10,\"class\",\"field\"],[8],[0,\"\\n  \"],[7,\"label\",true],[8],[0,\"\\n    \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"eventsAgendaEnabled\"]]]]],false],[0,\"\\n    \"],[1,[28,\"i18n\",[\"category.enable_events_agenda\"],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"section\",true],[10,\"class\",\"field\"],[8],[0,\"\\n  \"],[7,\"label\",true],[8],[0,\"\\n    \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"eventsCalendarEnabled\"]]]]],false],[0,\"\\n    \"],[1,[28,\"i18n\",[\"category.enable_events_calendar\"],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"section\",true],[10,\"class\",\"field\"],[8],[0,\"\\n  \"],[7,\"label\",true],[8],[0,\"\\n    \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"eventsEventLabelNoText\"]]]]],false],[0,\"\\n    \"],[1,[28,\"i18n\",[\"category.events_event_label_no_text\"],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"section\",true],[10,\"class\",\"field\"],[8],[0,\"\\n  \"],[7,\"label\",true],[8],[0,\"\\n    \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"eventsRequired\"]]]]],false],[0,\"\\n    \"],[1,[28,\"i18n\",[\"category.require_event\"],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/category-custom-settings/enable-events"}});
define("discourse/plugins/discourse-events/discourse/connectors/category-custom-settings/enable-events", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    setupComponent: function setupComponent(attrs, component) {
      if (!attrs.category.custom_fields) {
        attrs.category.custom_fields = {};
      }

      var settingValueToggle = function settingValueToggle(name) {
        var settings = component.siteSettings;
        var siteEnabled = settings[name];
        var categorySetting = attrs.category.custom_fields[name];
        var property = name.camelize();
        var value = categorySetting !== undefined ? categorySetting : siteEnabled;
        component.set(property, value);
        component.addObserver(property, function () {
          if (this._state === 'destroying') return;
          attrs.category.custom_fields[name] = component.get(property);
        });
      };

      settingValueToggle('events_enabled');
      settingValueToggle('events_agenda_enabled');
      settingValueToggle('events_calendar_enabled');
      settingValueToggle('events_event_label_no_text');
      settingValueToggle('events_required');
    }
  };
  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/discourse/connectors/composer-fields/composer-controls-event"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"model\",\"showEventControls\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"add-event-controls\",null,[[\"event\",\"category\",\"noText\"],[[24,[\"model\",\"event\"]],[24,[\"model\",\"category\"]],[24,[\"site\",\"mobileView\"]]]]],false],[0,\"\\n  \"],[1,[28,\"popup-input-tip\",null,[[\"validation\"],[[24,[\"eventValidation\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/composer-fields/composer-controls-event"}});
define("discourse/plugins/discourse-events/discourse/connectors/composer-fields/composer-controls-event", ["exports", "discourse-common/lib/get-owner"], function (_exports, _getOwner) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    setupComponent: function setupComponent(attrs, component) {
      var _this = this;

      var controller = (0, _getOwner.getOwner)(this).lookup('controller:composer');
      component.set('eventValidation', controller.get('eventValidation'));
      controller.addObserver('eventValidation', function () {
        if (_this._state === 'destroying') return;
        component.set('eventValidation', controller.get('eventValidation'));
      });
    }
  };
  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/discourse/connectors/edit-topic/topic-controls-event"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"showEventControls\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"add-event-controls\",null,[[\"event\",\"category\",\"noText\"],[[24,[\"buffered\",\"event\"]],[24,[\"buffered\",\"category\"]],[24,[\"site\",\"mobileView\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/edit-topic/topic-controls-event"}});
define("discourse/plugins/discourse-events/discourse/connectors/edit-topic/topic-controls-event", ["exports", "discourse-common/lib/get-owner", "discourse/models/category"], function (_exports, _getOwner, _category) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    setupComponent: function setupComponent(attrs, component) {
      var _this = this;

      var buffered = this.get('buffered');
      var user = component.currentUser;

      var showEventControls = function showEventControls(category) {
        return category && category.events_enabled && (user.staff || user.trust_level >= category.events_min_trust_to_create);
      };

      component.set('showEventControls', showEventControls(buffered.get('category')));
      buffered.addObserver('category_id', function () {
        if (_this._state === 'destroying') return;

        var category = _category.default.findById(_this.get('buffered.category_id'));

        component.set('showEventControls', showEventControls(category));
      });
    }
  };
  _exports.default = _default;
});
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.siteSettings.events_rsvp",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(2, data, 0),"inverse":container.noop,"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":11,"column":9}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.event.rsvp",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(3, data, 0),"inverse":container.noop,"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":10,"column":11}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"topic-list-event-rsvp\">\n        <a href=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.lastUnreadUrl",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":5,"column":17},"end":{"line":5,"column":48}}}))
    + "\" class=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.topicListItemClasses",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":5,"column":57},"end":{"line":5,"column":95}}}))
    + "\">\n          <span>"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.event_going_total",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":6,"column":16},"end":{"line":6,"column":51}}}))
    + "</span>\n          <span>"
    + container.escapeExpression((lookupProperty(helpers,"i18n")||(depth0 && lookupProperty(depth0,"i18n"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"event_rsvp.going.label",{"name":"i18n","hash":{},"hashTypes":{},"hashContexts":{},"types":["StringLiteral"],"contexts":[depth0],"data":data,"loc":{"start":{"line":7,"column":16},"end":{"line":7,"column":49}}}))
    + "</span>\n        </a>\n      </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.event",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(1, data, 0),"inverse":container.noop,"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":12,"column":7}}})) != null ? stack1 : "");
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/discourse/connectors/topic-list-after-title/topic-list-event-rsvp", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"date-time-container\">\n    <a href=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.lastUnreadUrl",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":3,"column":13},"end":{"line":3,"column":44}}}))
    + "\" class=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.topicListItemClasses",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":3,"column":53},"end":{"line":3,"column":91}}}))
    + "\">\n      "
    + container.escapeExpression((lookupProperty(helpers,"event-label")||(depth0 && lookupProperty(depth0,"event-label"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.event",{"name":"event-label","hash":{"list":"true"},"hashTypes":{"list":"StringLiteral"},"hashContexts":{"list":depth0},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":4,"column":6},"end":{"line":4,"column":53}}}))
    + "\n    </a>\n  </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.event",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(1, data, 0),"inverse":container.noop,"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":7,"column":7}}})) != null ? stack1 : "");
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/discourse/connectors/topic-list-before-status/topic-list-event-label", __t);
Ember.TEMPLATES["javascripts/discourse/connectors/topic-title/event-details"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"unless\",[[24,[\"model\",\"editingTopic\"]]],null,{\"statements\":[[4,\"if\",[[24,[\"model\",\"event\"]]],null,{\"statements\":[[0,\"    \"],[7,\"div\",true],[10,\"class\",\"event-date-mobile\"],[8],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"event-label\"],[8],[0,\"\\n        \"],[1,[28,\"event-label\",[[24,[\"model\",\"event\"]]],[[\"topic\"],[\"true\"]]],false],[0,\"\\n      \"],[9],[0,\"\\n\"],[4,\"if\",[[24,[\"siteSettings\",\"events_add_to_calendar\"]]],null,{\"statements\":[[0,\"        \"],[1,[28,\"add-to-calendar\",null,[[\"topic\"],[[24,[\"model\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"    \"],[9],[0,\"\\n\"],[4,\"if\",[[24,[\"showRsvp\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"event-rsvp\",null,[[\"topic\"],[[24,[\"model\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]},null]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/topic-title/event-details"}});
define("discourse/plugins/discourse-events/discourse/connectors/topic-title/event-details", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    setupComponent: function setupComponent(attrs, component) {
      var _this = this;

      var topic = attrs.model;
      var showRsvp = component.siteSettings.events_rsvp && topic.get('event.rsvp');
      component.set('showRsvp', showRsvp);
      topic.addObserver('event.rsvp', function () {
        if (_this._state === 'destroying') return;
        component.set('showRsvp', component.siteSettings.events_rsvp && topic.get('event.rsvp'));
      });
    }
  };
  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/discourse/connectors/user-preferences-interface/calendar-preferences"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"div\",true],[10,\"class\",\"control-group calendar\"],[8],[0,\"\\n  \"],[7,\"label\",true],[10,\"class\",\"control-label\"],[8],[1,[28,\"i18n\",[\"user.events_calendar.label\"],null],false],[9],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n    \"],[7,\"label\",true],[8],[1,[28,\"i18n\",[\"user.events_calendar.first_day_week\"],null],false],[9],[0,\"\\n    \"],[1,[28,\"combo-box\",null,[[\"content\",\"value\"],[[24,[\"weekdaysAvailable\"]],[24,[\"controller\",\"model\",\"custom_fields\",\"calendar_first_day_week\"]]]]],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/user-preferences-interface/calendar-preferences"}});
define("discourse/plugins/discourse-events/discourse/connectors/user-preferences-interface/calendar-preferences", ["exports", "discourse-common/lib/get-owner", "I18n"], function (_exports, _getOwner, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    setupComponent: function setupComponent(attrs, component) {
      var controller = (0, _getOwner.getOwner)(this).lookup('controller:preferences/interface');
      moment.locale(_I18n.default.locale);
      var data = moment.localeData();
      var weekdaysRaw = data.weekdays();
      var weekdaysAvailable = Object.keys(weekdaysRaw).reduce(function (weekdays, day) {
        if (day === '6' || day <= '1') {
          weekdays.push({
            id: Number(day),
            name: weekdaysRaw[day]
          });
        }

        return weekdays;
      }, []); // move saturday to the start

      weekdaysAvailable.unshift(weekdaysAvailable.pop());
      component.setProperties({
        weekdaysAvailable: weekdaysAvailable,
        controller: controller
      });

      if (!controller.get('model.custom_fields.calendar_first_day_week')) {
        var userFirst = controller.get('model.calendar_first_day_week');
        var localeFirst = data.firstDayOfWeek();
        var first = !isNaN(parseFloat(userFirst)) && isFinite(userFirst) ? userFirst : localeFirst;
        controller.set('model.custom_fields.calendar_first_day_week', first);
      }
    }
  };
  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/discourse/connectors/user-preferences-nav/event-ical-key"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"li\",true],[10,\"class\",\"nav-webcal-keys\"],[8],[0,\"\\n\"],[4,\"link-to\",null,[[\"route\"],[\"preferences.webcal-keys\"]],{\"statements\":[[0,\"    \"],[1,[28,\"i18n\",[\"webcal_preferences.webcal_keys\"],null],false],[0,\"\\n\"]],\"parameters\":[]},null],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/user-preferences-nav/event-ical-key"}});
define("discourse/plugins/discourse-events/discourse/controllers/add-event", ["exports", "discourse/mixins/modal-functionality", "@ember/controller", "I18n"], function (_exports, _modalFunctionality, _controller, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _controller.default.extend(_modalFunctionality.default, {
    title: 'add_event.modal_title',
    actions: {
      clear: function clear() {
        this.set('bufferedEvent', null);
      },
      saveEvent: function saveEvent() {
        if (this.valid) {
          this.get('model.update')(this.bufferedEvent);
          this.send('closeModal');
        } else {
          this.flash(_I18n.default.t('add_event.error'), 'error');
        }
      },
      updateEvent: function updateEvent(event, valid) {
        this.set('bufferedEvent', event);
        this.set('valid', valid);
      }
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/controllers/event-rsvp", ["exports", "discourse-common/utils/decorators", "discourse-common/lib/get-owner", "discourse/lib/ajax", "discourse/mixins/modal-functionality", "discourse/lib/ajax-error", "@ember/controller"], function (_exports, _decorators, _getOwner, _ajax, _modalFunctionality, _ajaxError, _controller) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _controller.default.extend(_modalFunctionality.default, (_dec = (0, _decorators.observes)('type', 'model.topic'), _dec2 = (0, _decorators.default)('type'), _dec3 = (0, _decorators.default)('userList', 'filter'), (_obj = {
    filter: null,
    userList: [],
    type: 'going',
    setUserList: function setUserList() {
      var _this = this;

      this.set('loadingList', true);
      var type = this.get('type');
      var topic = this.get('model.topic');
      var usernames = topic.get("event.".concat(type));
      if (!usernames || !usernames.length) return;
      var userList = [];
      (0, _ajax.ajax)('/calendar-events/rsvp/users', {
        data: {
          usernames: usernames
        }
      }).then(function (response) {
        var userList = response.users || [];

        _this.setProperties({
          userList: userList,
          loadingList: false
        });
      }).catch(function (e) {
        _this.flash((0, _ajaxError.extractError)(e), 'alert-error');
      }).finally(function () {
        _this.setProperties({
          loadingList: false
        });
      });
    },
    goingNavClass: function goingNavClass(type) {
      return type === 'going' ? 'active' : '';
    },
    filteredList: function filteredList(userList, filter) {
      if (filter) {
        userList = userList.filter(function (u) {
          return u.username.indexOf(filter) > -1;
        });
      }

      var currentUser = this.get('currentUser');

      if (currentUser) {
        userList.sort(function (a, b) {
          if (a.username === currentUser.username) {
            return -1;
          } else {
            return 1;
          }
        });
      }

      return userList;
    },
    actions: {
      setType: function setType(type) {
        this.set('type', type);
      },
      composePrivateMessage: function composePrivateMessage(user) {
        var controller = (0, _getOwner.getOwner)(this).lookup('controller:application');
        this.send('closeModal');
        controller.send('composePrivateMessage', user);
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "setUserList", [_dec], Object.getOwnPropertyDescriptor(_obj, "setUserList"), _obj), _applyDecoratedDescriptor(_obj, "goingNavClass", [_dec2], Object.getOwnPropertyDescriptor(_obj, "goingNavClass"), _obj), _applyDecoratedDescriptor(_obj, "filteredList", [_dec3], Object.getOwnPropertyDescriptor(_obj, "filteredList"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/event-route-map", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    resource: 'user.preferences',
    map: function map() {
      this.route('webcal-keys');
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/helpers/event-label", ["exports", "discourse-common/lib/helpers", "@ember/template", "../lib/date-utilities"], function (_exports, _helpers, _template, _dateUtilities) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _helpers.registerUnbound)('event-label', function (event, args) {
    var siteSettings = (0, _helpers.helperContext)().siteSettings;
    return (0, _template.htmlSafe)((0, _dateUtilities.eventLabel)(event, Object.assign({}, args, {
      siteSettings: siteSettings
    })));
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/initializers/event-edits", ["exports", "discourse/models/composer", "discourse/models/category", "discourse/components/composer-body", "discourse/models/topic", "discourse/controllers/topic", "discourse-common/utils/decorators", "discourse/models/nav-item", "discourse/components/edit-category-settings", "discourse/components/topic-list-item", "discourse/lib/url", "discourse/lib/plugin-api", "../lib/date-utilities", "@ember/runloop", "@ember/object", "I18n"], function (_exports, _composer, _category, _composerBody, _topic, _topic2, _decorators, _navItem, _editCategorySettings, _topicListItem, _url, _pluginApi, _dateUtilities, _runloop, _object, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = {
    name: 'events-edits',
    initialize: function initialize(container) {
      var _dec, _dec2, _obj, _dec3, _dec4, _obj2, _init, _dec5, _dec6, _dec7, _obj3, _dec8, _obj4, _dec9, _dec10, _dec11, _obj5, _dec12, _obj6;

      var siteSettings = container.lookup('site-settings:main');
      var currentUser = container.lookup("current-user:main");

      _composer.default.serializeOnCreate('event');

      _composer.default.serializeToTopic('event', 'topic.event');

      _composer.default.reopen((_dec = (0, _decorators.default)('subtype', 'category.events_enabled', 'topicFirstPost', 'topic.event', 'canCreateEvent'), _dec2 = (0, _decorators.default)('category.events_min_trust_to_create'), (_obj = {
        showEventControls: function showEventControls(subtype, categoryEnabled, topicFirstPost, event, canCreateEvent) {
          return topicFirstPost && (subtype === 'event' || categoryEnabled || event) && canCreateEvent;
        },
        canCreateEvent: function canCreateEvent(minTrust) {
          return currentUser.staff || currentUser.trust_level >= minTrust;
        }
      }, (_applyDecoratedDescriptor(_obj, "showEventControls", [_dec], Object.getOwnPropertyDescriptor(_obj, "showEventControls"), _obj), _applyDecoratedDescriptor(_obj, "canCreateEvent", [_dec2], Object.getOwnPropertyDescriptor(_obj, "canCreateEvent"), _obj)), _obj)));

      _composerBody.default.reopen((_dec3 = (0, _decorators.observes)('composer.event'), _dec4 = (0, _decorators.observes)('composer.showEventControls', 'composer.composeState'), (_obj2 = {
        resizeWhenEventAdded: function resizeWhenEventAdded() {
          this.resize();
        },
        applyEventInlineClass: function applyEventInlineClass() {
          var _this = this;

          (0, _runloop.scheduleOnce)('afterRender', this, function () {
            var showEventControls = _this.get('composer.showEventControls');

            var $container = $('.composer-fields .title-and-category');
            $container.toggleClass('show-event-controls', Boolean(showEventControls));

            if (showEventControls) {
              var $anchor = _this.site.mobileView ? $container.find('.title-input') : $container;
              $('.composer-controls-event').appendTo($anchor);
            }

            _this.resize();
          });
        }
      }, (_applyDecoratedDescriptor(_obj2, "resizeWhenEventAdded", [_dec3], (_init = Object.getOwnPropertyDescriptor(_obj2, "resizeWhenEventAdded"), _init = _init ? _init.value : undefined, {
        enumerable: true,
        configurable: true,
        writable: true,
        initializer: function initializer() {
          return _init;
        }
      }), _obj2), _applyDecoratedDescriptor(_obj2, "applyEventInlineClass", [_dec4], Object.getOwnPropertyDescriptor(_obj2, "applyEventInlineClass"), _obj2)), _obj2)));

      _topic.default.reopen((_dec5 = (0, _decorators.default)('subtype', 'category.events_enabled', 'canCreateEvent'), _dec6 = (0, _decorators.default)('category.events_min_trust_to_create'), _dec7 = (0, _decorators.default)('last_read_post_number', 'highest_post_number'), (_obj3 = {
        showEventControls: function showEventControls(subtype, categoryEnabled, canCreateEvent) {
          return (subtype === 'event' || categoryEnabled) && canCreateEvent;
        },
        canCreateEvent: function canCreateEvent(minTrust) {
          return currentUser.staff || currentUser.trust_level >= minTrust;
        },
        topicListItemClasses: function topicListItemClasses(lastRead, highest) {
          var classes = "date-time title raw-link event-link raw-topic-link";

          if (lastRead === highest) {
            classes += ' visited';
          }

          return classes;
        }
      }, (_applyDecoratedDescriptor(_obj3, "showEventControls", [_dec5], Object.getOwnPropertyDescriptor(_obj3, "showEventControls"), _obj3), _applyDecoratedDescriptor(_obj3, "canCreateEvent", [_dec6], Object.getOwnPropertyDescriptor(_obj3, "canCreateEvent"), _obj3), _applyDecoratedDescriptor(_obj3, "topicListItemClasses", [_dec7], Object.getOwnPropertyDescriptor(_obj3, "topicListItemClasses"), _obj3)), _obj3))); // necessary because topic-title plugin outlet only recieves model


      _topic2.default.reopen((_dec8 = (0, _decorators.observes)('editingTopic'), (_obj4 = {
        setEditingTopicOnModel: function setEditingTopicOnModel() {
          this.set('model.editingTopic', this.get('editingTopic'));
        }
      }, (_applyDecoratedDescriptor(_obj4, "setEditingTopicOnModel", [_dec8], Object.getOwnPropertyDescriptor(_obj4, "setEditingTopicOnModel"), _obj4)), _obj4)));

      _navItem.default.reopenClass({
        buildList: function buildList(category, args) {
          var items = this._super(category, args);

          if (category) {
            items = items.reject(function (item) {
              return item.name === 'agenda' || item.name === 'calendar';
            });

            if (category.events_agenda_enabled) {
              items.push(_navItem.default.fromText('agenda', args));
            }

            if (category.events_calendar_enabled) {
              items.push(_navItem.default.fromText('calendar', args));
            }
          }

          return items;
        }
      });

      _topicListItem.default.reopen((_dec9 = (0, _decorators.on)('didInsertElement'), _dec10 = (0, _decorators.on)('willDestroyElement'), _dec11 = (0, _decorators.on)('didRender'), (_obj5 = {
        setupEventLink: function setupEventLink() {
          var _this2 = this;

          (0, _runloop.scheduleOnce)('afterRender', this, function () {
            $('.event-link', _this2.element).on('click', (0, _runloop.bind)(_this2, _this2.handleEventLabelClick));
          });
        },
        teardownEventLink: function teardownEventLink() {
          $('.event-link', this.element).off('click', (0, _runloop.bind)(this, this.handleEventLabelClick));
        },
        handleEventLabelClick: function handleEventLabelClick(e) {
          e.preventDefault();
          var topic = this.get('topic');
          var href = $(e.target).attr("href");
          this.appEvents.trigger('header:update-topic', topic);

          _url.default.routeTo(href);
        },
        moveElements: function moveElements() {
          var _this3 = this;

          var topic = this.get('topic');
          (0, _runloop.scheduleOnce)('afterRender', function () {
            var $linkTopLine = $('.link-top-line', _this3.element);
            var rowBelowTitle = false;

            if (topic.event && topic.event.rsvp) {
              $('.topic-list-event-rsvp', _this3.element).insertAfter($linkTopLine);
              rowBelowTitle = true;
            }

            if (_this3.siteSettings.events_event_label_short_after_title) {
              $('.date-time-container', _this3.element).insertAfter($linkTopLine);
              rowBelowTitle = true;
            }

            if (rowBelowTitle) {
              $('.main-link', _this3.element).addClass('row-below-title');
            }
          });
        }
      }, (_applyDecoratedDescriptor(_obj5, "setupEventLink", [_dec9], Object.getOwnPropertyDescriptor(_obj5, "setupEventLink"), _obj5), _applyDecoratedDescriptor(_obj5, "teardownEventLink", [_dec10], Object.getOwnPropertyDescriptor(_obj5, "teardownEventLink"), _obj5), _applyDecoratedDescriptor(_obj5, "moveElements", [_dec11], Object.getOwnPropertyDescriptor(_obj5, "moveElements"), _obj5)), _obj5)));

      _editCategorySettings.default.reopen((_dec12 = (0, _decorators.default)('category'), (_obj6 = {
        availableViews: function availableViews(category) {
          var views = this._super.apply(this, arguments);

          if (category.get('custom_fields.events_agenda_enabled')) {
            views.push({
              name: _I18n.default.t('filters.agenda.title'),
              value: 'agenda'
            });
          }

          if (category.get('custom_fields.events_calendar_enabled')) {
            views.push({
              name: _I18n.default.t('filters.calendar.title'),
              value: 'calendar'
            });
          }

          return views;
        }
      }, (_applyDecoratedDescriptor(_obj6, "availableViews", [_dec12], Object.getOwnPropertyDescriptor(_obj6, "availableViews"), _obj6)), _obj6)));

      var calendarRoutes = ["Calendar", "CalendarCategory", "CalendarCategoryNone"];
      calendarRoutes.forEach(function (route) {
        var route = container.lookup("route:discovery.".concat(route));
        route.reopen({
          beforeModel: function beforeModel(transition) {
            var routeName = this.routeName;
            var queryParams = this.paramsFor(routeName);

            if (!queryParams.start || !queryParams.end) {
              var month = moment().month();
              var year = moment().year();

              var _calendarRange = (0, _dateUtilities.calendarRange)(month, year),
                  start = _calendarRange.start,
                  end = _calendarRange.end;

              this.setProperties({
                start: start,
                end: end
              });
            }

            this._super(transition);
          },
          setupController: function setupController(controller, model) {
            var start = this.get('start');
            var end = this.get('end');

            if (start || end) {
              var initialDateRange = {};
              if (start) initialDateRange['start'] = start;
              if (end) initialDateRange['end'] = end;
              this.controllerFor("discovery/topics").setProperties({
                initialDateRange: initialDateRange
              });
            }

            this._super(controller, model);
          },
          renderTemplate: function renderTemplate(controller, model) {
            // respect discourse-layouts settings
            var global = siteSettings.layouts_list_navigation_disabled_global;
            var catGlobal = model.category && model.category.get('layouts_list_navigation_disabled_global');

            if (!global && !catGlobal) {
              if (this.routeName.indexOf('Category') > -1) {
                this.render('navigation/category', {
                  outlet: 'navigation-bar'
                });
              } else {
                this.render('navigation/default', {
                  outlet: 'navigation-bar'
                });
              }
            }

            this.render("discovery/calendar", {
              outlet: "list-container",
              controller: 'discovery/topics'
            });
          }
        });
      });
      var categoryRoutes = ['category', 'categoryNone'];
      categoryRoutes.forEach(function (route) {
        (0, _pluginApi.withPluginApi)('0.8.12', function (api) {
          api.modifyClass("route:discovery.".concat(route), {
            pluginId: 'events',
            afterModel: function afterModel(model, transition) {
              var filter = this.filter(model.category);

              if (filter === 'calendar' || filter === 'agenda') {
                return this.replaceWith("/c/".concat(_category.default.slugFor(model.category), "/l/").concat(this.filter(model.category)));
              } else {
                return this._super.apply(this, arguments);
              }
            }
          });
        });
      });
      (0, _pluginApi.withPluginApi)('0.8.33', function (api) {
        api.serializeToDraft('event');
      });
      (0, _pluginApi.withPluginApi)('0.8.12', function (api) {
        var _dec13, _obj7, _dec15, _obj9, _dec16, _obj10;

        api.addDiscoveryQueryParam('end', {
          replace: true,
          refreshModel: true
        });
        api.addDiscoveryQueryParam('start', {
          replace: true,
          refreshModel: true
        });
        api.modifyClass('controller:preferences/interface', (_dec13 = (0, _decorators.default)("makeThemeDefault"), (_obj7 = {
          pluginId: 'events',
          saveAttrNames: function saveAttrNames(makeDefault) {
            var attrs = this._super(makeDefault);

            attrs.push('custom_fields');
            return attrs;
          }
        }, (_applyDecoratedDescriptor(_obj7, "saveAttrNames", [_dec13], Object.getOwnPropertyDescriptor(_obj7, "saveAttrNames"), _obj7)), _obj7)));

        if (siteSettings.events_hamburger_menu_calendar_link) {
          api.decorateWidget('hamburger-menu:generalLinks', function (helper) {
            return {
              route: 'discovery.calendar',
              className: 'calendar-link',
              label: 'filters.calendar.title'
            };
          });
        }

        if (siteSettings.events_hamburger_menu_agenda_link) {
          api.decorateWidget('hamburger-menu:generalLinks', function (helper) {
            return {
              route: 'discovery.agenda',
              className: 'agenda-link',
              label: 'filters.agenda.title'
            };
          });
        }

        var user = api.getCurrentUser();

        if (user && user.admin) {
          var _dec14, _obj8;

          api.modifyClass('model:site-setting', (_dec14 = (0, _decorators.default)('valid_values'), (_obj8 = {
            pluginId: 'events',
            allowsNone: function allowsNone() {
              if (this.get('setting') === 'events_timezone_default') {
                return 'site_settings.events_timezone_default_placeholder';
              } else {
                this._super();
              }
            }
          }, (_applyDecoratedDescriptor(_obj8, "allowsNone", [_dec14], Object.getOwnPropertyDescriptor(_obj8, "allowsNone"), _obj8)), _obj8)));
        }

        api.modifyClass('controller:topic', (_dec15 = (0, _decorators.observes)('model.id'), (_obj9 = {
          pluginId: 'events',
          subscribeCalendarEvents: function subscribeCalendarEvents() {
            var _this4 = this;

            this.unsubscribeCalendarEvents();
            this.messageBus.subscribe("/calendar-events/".concat(this.get('model.id')), function (data) {
              var topic = _this4.get('model');

              var currentUser = _this4.get('currentUser');

              if (data.current_user_id === currentUser.id) return;

              switch (data.type) {
                case "rsvp":
                  {
                    var prop = Object.keys(data).filter(function (p) {
                      return p.indexOf('event') > -1;
                    });

                    if (prop && prop[0]) {
                      var key = prop[0].split('_').join('.');

                      _this4.set("model.".concat(key), data[prop[0]]);

                      _this4.notifyPropertyChange("model.".concat(prop));
                    }
                  }
              }
            });
          },
          unsubscribeCalendarEvents: function unsubscribeCalendarEvents() {
            this.messageBus.unsubscribe("/calendar-events/".concat(this.get('model.id')));
          }
        }, (_applyDecoratedDescriptor(_obj9, "subscribeCalendarEvents", [_dec15], Object.getOwnPropertyDescriptor(_obj9, "subscribeCalendarEvents"), _obj9)), _obj9)));
        api.modifyClass('controller:composer', (_dec16 = (0, _decorators.default)('model.action', 'model.event', 'model.category.events_required', 'lastValidatedAt'), (_obj10 = {
          pluginId: 'events',
          eventValidation: function eventValidation(action, event, eventsRequired, lastValidatedAt) {
            if (action === _composer.CREATE_TOPIC && eventsRequired && !event) {
              return _object.default.create({
                failed: true,
                reason: _I18n.default.t('composer.error.event_missing'),
                lastShownAt: lastValidatedAt
              });
            }
          },
          // overriding cantSubmitPost on the model is more fragile
          save: function save(opts) {
            if (!this.get('eventValidation')) {
              this._super.apply(this, arguments);
            } else {
              this.set('lastValidatedAt', Date.now());
            }
          }
        }, (_applyDecoratedDescriptor(_obj10, "eventValidation", [_dec16], Object.getOwnPropertyDescriptor(_obj10, "eventValidation"), _obj10)), _obj10)));
      });
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-events/discourse/lib/date-utilities", ["exports", "discourse-common/lib/icon-library", "discourse/models/site", "@ember/template", "I18n", "discourse/models/user"], function (_exports, _iconLibrary, _site, _template, _I18n, _user) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.eventLabel = eventLabel;
  _exports.googleUri = googleUri;
  _exports.icsUri = icsUri;
  _exports.eventsForDay = eventsForDay;
  _exports.setupEvent = setupEvent;
  _exports.compileEvent = compileEvent;
  _exports.setupEventForm = setupEventForm;
  _exports.timezoneLabel = timezoneLabel;
  _exports.firstDayOfWeek = firstDayOfWeek;
  _exports.calendarDays = calendarDays;
  _exports.calendarRange = calendarRange;
  _exports.getTimezone = getTimezone;
  _exports.nextInterval = nextInterval;
  _exports.eventCalculations = eventCalculations;
  _exports.formTimeFormat = void 0;
  var formDateFormat = 'YYYY-MM-DD';
  var formTimeFormat = 'HH:mm';
  _exports.formTimeFormat = formTimeFormat;
  var RANGE_FORMAT = 'YYYY-MM-DD';

  function getDefaultTimezone(args) {
    var setting = args.siteSettings.events_timezone_default;
    var user = moment.tz.guess();
    return setting ? setting : user;
  }

  ;

  function getTimezone() {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var timezone = getDefaultTimezone(args);

    if (event && event['timezone']) {
      var display = args.siteSettings.events_timezone_display;

      if (args.useEventTimezone || display === 'event' || display === 'different' && event['timezone'] !== timezone) {
        timezone = event['timezone'];
      }
    }

    return timezone;
  }

  ;

  function includeTimezone() {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!event) return false;
    if (args.useEventTimezone && event['timezone']) return true;
    var includeInTopicList = args.siteSettings.events_timezone_include_in_topic_list;
    if (args.list === 'true') return includeInTopicList;
    var includeInTopic = args.siteSettings.events_timezone_include_in_topic;
    if (args.topic === 'true') return includeInTopic;
    return false;
  }

  ;

  function isAllDay(event) {
    if (event['all_day'] === true || event['all_day'] === 'true') return true; // legacy check for events pre-addition of 'all_day' attribute

    var start = moment(event['start']);
    var end = moment(event['end']);
    var startIsDayStart = start.hour() === 0 && start.minute() === 0;
    var endIsDayEnd = end.hour() === 23 && end.minute() === 59;
    return startIsDayStart && endIsDayEnd;
  }

  ;

  function nextInterval() {
    var rounding = 30 * 60 * 1000;
    return moment(Math.ceil(+moment() / rounding) * rounding);
  }

  ;

  function uriDateTimes(event) {
    var format = event.all_day ? "YYYYMMDD" : "YYYYMMDDTHHmmss";
    var rawStart = event.start;
    var start = moment(rawStart).local().format(format);
    var rawEnd = moment(event.end || event.start);
    if (event.all_day) rawEnd = moment(rawEnd).add(1, 'days');
    var end = moment(rawEnd).local().format(format);
    return {
      start: start,
      end: end
    };
  }

  ;

  function googleUri(params) {
    var href = "https://www.google.com/calendar/render?action=TEMPLATE";

    if (params.title) {
      href += "&text=".concat(encodeURIComponent(params.title));
    }

    var _uriDateTimes = uriDateTimes(params.event),
        start = _uriDateTimes.start,
        end = _uriDateTimes.end;

    href += "&dates=".concat(start, "/").concat(end);
    href += "&details=".concat(params.details || _I18n.default.t('add_to_calendar.default_details', {
      url: params.url
    }));

    if (params.location) {
      href += "&location=".concat(params.location);
    }

    href += "&sf=true&output=xml";
    return href;
  }

  ;

  function icsUri(params) {
    var url = document.URL;
    var title = params.title;
    var details = params.details || '';
    var location = params.location || '';

    var _uriDateTimes2 = uriDateTimes(params.event),
        start = _uriDateTimes2.start,
        end = _uriDateTimes2.end;

    return encodeURI('data:text/calendar;charset=utf8,' + ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'URL:' + url, 'DTSTART:' + start, 'DTEND:' + end, 'SUMMARY:' + title, 'DESCRIPTION:' + details, 'LOCATION:' + location, 'END:VEVENT', 'END:VCALENDAR'].join('\n'));
  }

  ;

  function allDayAttrs(attrs, topic, startIsSame, endIsSame, isBetween) {
    attrs['classes'] += ' all-day';
    attrs['allDay'] = true;

    if (startIsSame) {
      attrs['classes'] += ' start';
    }

    if (endIsSame) {
      attrs['classes'] += ' end';
    }

    if (isBetween) {
      attrs['classes'] += ' is-between';
    }

    if (!endIsSame || isBetween) {
      attrs['classes'] += ' multi';
    }

    if (topic.category) {
      attrs['listStyle'] += "background-color: #".concat(topic.category.color, ";");
    }

    return attrs;
  }

  ;

  function eventCalculations(day, start, end) {
    // equivalent momentjs comparisons dont work well with all-day timezone handling
    var date = day.date();
    var month = day.month();
    var year = day.year();
    var startDate = start.date();
    var startMonth = start.month();
    var startYear = start.year();
    var startIsSame = date === startDate && month === startMonth && year === startYear;
    var endIsSame = false;
    var isBetween = false;
    var daysLeft = 1;

    if (end) {
      var endDate = end.date();
      var endMonth = end.month();
      var endYear = end.year();
      endIsSame = end && date === endDate && month === endMonth && year === endYear;
      var startIsBefore = year > startYear || year === startYear && (month > startMonth || month === startMonth && date > startDate);
      var endIsAfter = year < endYear || year === endYear && (month < endMonth || month === endMonth && date < endDate);
      isBetween = startIsBefore && endIsAfter;
      daysLeft = month === endMonth ? endDate - date + 1 : moment(end).diff(moment(day), 'days');
    }

    return {
      startIsSame: startIsSame,
      endIsSame: endIsSame,
      isBetween: isBetween,
      daysLeft: daysLeft
    };
  }

  ;
  var allowedFirstDays = [6, 0, 1]; // Saturday, Sunday, Monday

  function firstDayOfWeek() {
    var user = _user.default.current();

    return user && allowedFirstDays.indexOf(user.calendar_first_day_week) > -1 ? user.calendar_first_day_week : moment().weekday(0).day();
  }

  ;

  function calendarDays(month, year) {
    var firstDayMonth = moment().year(year).month(month).date(1);
    var firstDayWeek = firstDayOfWeek();
    var start;
    var diff;

    if (firstDayMonth.day() >= firstDayWeek) {
      diff = firstDayMonth.day() - firstDayWeek;
      start = firstDayMonth.day(firstDayWeek);
    } else {
      if (firstDayWeek === 1) {
        // firstDayMonth has to be 0, i.e. Sunday
        diff = 6;
      } else {
        // islamic calendar starts on 6, i.e. Saturday
        diff = firstDayMonth.day() + 1;
      }

      start = firstDayMonth.subtract(diff, 'days');
    }

    var count = 35;
    if (diff + moment().year(year).month(month).daysInMonth() > 35) count = 42;
    var end = moment(start).add(count, 'days');
    return {
      start: start,
      end: end
    };
  }

  ;

  function calendarRange(month, year) {
    var _calendarDays = calendarDays(month, year),
        start = _calendarDays.start,
        end = _calendarDays.end;

    return {
      start: start.format(RANGE_FORMAT),
      end: end.format(RANGE_FORMAT)
    };
  }

  ;

  function compileDateTime(params, type) {
    var year = moment(params["".concat(type, "Date")]).year();
    var month = moment(params["".concat(type, "Date")]).month();
    var date = moment(params["".concat(type, "Date")]).date();
    var hour = params.allDay ? 0 : moment(params["".concat(type, "Time")], 'HH:mm').hour();
    var min = params.allDay ? 0 : moment(params["".concat(type, "Time")], 'HH:mm').minute();
    var dateTime = moment();
    dateTime.tz(params.timezone);
    return dateTime.year(year).month(month).date(date).hour(hour).minute(min).second(0).millisecond(0).toISOString();
  }

  ;

  function compileEvent(params) {
    var event = null;

    if (params.startDate) {
      event = {
        timezone: params.timezone,
        all_day: params.allDay,
        start: compileDateTime(params, 'start')
      };

      if (params.endEnabled) {
        event.end = compileDateTime(params, 'end');
      }
    }

    if (params.rsvpEnabled) {
      event.rsvp = true;

      if (params.goingMax) {
        event.going_max = params.goingMax;
      }

      if (params.usersGoing) {
        event.going = params.usersGoing.split(',');
      }
    }

    return event;
  }

  ;

  function eventLabel(event) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var siteSettings = args.siteSettings || {};
    var icon = siteSettings.events_event_label_icon;
    var standardFormat = siteSettings.events_event_label_format;
    var listFormat = siteSettings.events_event_label_short_format;
    var listOnlyStart = siteSettings.events_event_label_short_only_start;
    var format = args.list ? listFormat : standardFormat;
    var iconClass = '';
    if (!format) iconClass += 'no-date';
    var label = (0, _iconLibrary.renderIcon)("string", icon, {
      class: iconClass
    });

    if (!args.noText) {
      var _setupEvent = setupEvent(event, args),
          start = _setupEvent.start,
          end = _setupEvent.end,
          allDay = _setupEvent.allDay,
          multiDay = _setupEvent.multiDay,
          timezone = _setupEvent.timezone;

      var dateString = '';
      var dateClass = 'date';

      if (format) {
        var formatArr = format.split(',');
        if (allDay) format = formatArr[0];
        dateString = start.format(format);

        if (event['end'] && (!args.list || !listOnlyStart)) {
          var diffDay = start.month() !== end.month() || start.date() !== end.date();

          if (!allDay || diffDay) {
            var endFormat = diffDay || allDay ? format : formatArr[formatArr.length - 1];
            dateString += " \u2013 ".concat(end.format(endFormat));
          }
        }

        if (timezone && includeTimezone(event, args)) {
          dateString += ", ".concat(timezoneLabel(timezone, args));
        }
      } else {
        dateClass += ' no-date';
      }

      label += "<span class=\"".concat(dateClass, "\">").concat(dateString, "</span>");

      if (args.showRsvp) {
        if (event.rsvp) {
          label += '<span class="dot">&middot;</span>';
          label += "<span class=\"rsvp\">".concat(_I18n.default.t('add_event.rsvp_enabled_label'), "</span>");

          if (event.going_max) {
            label += '<span class="dot">&middot;</span>';
            label += "<span class=\"going-max\">".concat(_I18n.default.t('add_event.going_max_label', {
              goingMax: event.going_max
            }), "</span>");
          }
        }
      }
    }

    return label;
  }

  ;

  function setupEvent(event) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var start;
    var end;
    var allDay;
    var multiDay;
    var timezone;

    if (event) {
      start = moment(event['start']);
      allDay = isAllDay(event);

      if (event['end']) {
        end = moment(event['end']);
        multiDay = end.date() > start.date() || end.month() > start.month();
      }

      if (!allDay) {
        timezone = getTimezone(event, args);

        if (timezone) {
          start = start.tz(timezone);

          if (event['end']) {
            end = end.tz(timezone);
          }
        }
      }
    }

    return {
      start: start,
      end: end,
      allDay: allDay,
      multiDay: multiDay,
      timezone: timezone
    };
  }

  ;

  function timezoneLabel(tz) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // if there is a custom moment.js format use that
    var formatSetting = args.siteSettings.events_timezone_format;

    if (formatSetting) {
      return moment.tz(tz).format(formatSetting);
    } // if the Rails format setting is enabled,
    // and the zone has a Rails standard format, use that


    var timezones = _site.default.currentProp('event_timezones');

    var railsFormatSetting = args.siteSettings.events_timezone_rails_format;

    if (timezones && railsFormatSetting) {
      var standard = timezones.find(function (tzObj) {
        return tzObj.value === tz;
      });
      if (standard) return standard.name;
    } // fallback to IANA name if there is no custom format and
    // Rails format is disabled or zone is not part of the Rails standard set.


    var offset = moment.tz(tz).format('Z');
    var raw = tz;
    var name = raw.replace('_', '');
    return "(".concat(offset, ") ").concat(name);
  }

  ;

  function setupEventForm(event) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _setupEvent2 = setupEvent(event, Object.assign(args, {
      useEventTimezone: true
    })),
        start = _setupEvent2.start,
        end = _setupEvent2.end,
        allDay = _setupEvent2.allDay,
        multiDay = _setupEvent2.multiDay,
        timezone = _setupEvent2.timezone;

    var props = {};

    if (allDay) {
      var startDate = start.format(formDateFormat);
      var endDate = end ? end.format(formDateFormat) : startDate;
      var endEnabled = moment(endDate).isAfter(startDate, 'day');
      props = {
        allDay: allDay,
        startDate: startDate,
        endDate: endDate,
        endEnabled: endEnabled
      };
    } else if (start) {
      props['startDate'] = start.format(formDateFormat);
      props['startTime'] = start.format(formTimeFormat);

      if (end) {
        var _endDate = end.format(formDateFormat);

        var endTime = end.format(formTimeFormat);
        props['endDate'] = _endDate;
        props['endTime'] = endTime;
        props['endEnabled'] = true;
      }
    } else {
      props['startDate'] = moment().format(formDateFormat);
      props['startTime'] = nextInterval().format(formTimeFormat);
    }

    props['timezone'] = timezone || args.siteSettings.events_timezone_default;

    if (event && event.rsvp) {
      props['rsvpEnabled'] = true;

      if (event.going_max) {
        props['goingMax'] = event.going_max;
      }

      if (event.going) {
        props['usersGoing'] = event.going.join(',');
      }
    }

    return props;
  }

  ;

  function eventsForDay(day, topics) {
    var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var events = topics.filter(function (t) {
      return t.event;
    });
    var fullWidth = args.dateEvents || args.expanded;
    var blockIndex = 0;
    return events.reduce(function (dayEvents, topic) {
      var _setupEvent3 = setupEvent(topic.event, args),
          start = _setupEvent3.start,
          end = _setupEvent3.end,
          allDay = _setupEvent3.allDay,
          multiDay = _setupEvent3.multiDay;

      var _eventCalculations = eventCalculations(day, start, end),
          startIsSame = _eventCalculations.startIsSame,
          endIsSame = _eventCalculations.endIsSame,
          isBetween = _eventCalculations.isBetween,
          daysLeft = _eventCalculations.daysLeft;

      var onThisDay = startIsSame || endIsSame || isBetween;

      if (onThisDay) {
        var attrs = {
          topic: topic,
          classes: 'event',
          listStyle: ''
        };

        if (fullWidth) {
          attrs['classes'] += ' full-width';
        }

        var blockStyle = allDay || multiDay;

        if (blockStyle) {
          attrs = allDayAttrs(attrs, topic, startIsSame, endIsSame, isBetween);

          if (topic.event.blockIndex === undefined) {
            topic.event.blockIndex = blockIndex;
          }

          blockIndex++;
        } else if (topic.category) {
          attrs['dotStyle'] = (0, _template.htmlSafe)("color: #".concat(topic.category.color));
        }

        if (!allDay && (!multiDay || startIsSame)) {
          var timeFormat = args.siteSettings.events_event_time_calendar_format;
          attrs['time'] = start.format(timeFormat);
        }

        if (startIsSame || fullWidth || args.rowIndex === 0) {
          attrs['title'] = topic.title;

          if ((multiDay || allDay) && !fullWidth) {
            var remainingInRow = 7 - args.rowIndex;
            var daysInRow = daysLeft >= remainingInRow ? remainingInRow : daysLeft;
            var buffer = 20;
            if (attrs['time']) buffer += 55;
            var tStyle = "width:calc((100%*".concat(daysInRow, ") - ").concat(buffer, "px);background-color:#").concat(topic.category.color, ";");
            attrs['titleStyle'] = (0, _template.htmlSafe)(tStyle);
          }
        }

        attrs['listStyle'] = (0, _template.htmlSafe)(attrs['listStyle']); // Add placeholders if necessary

        if (blockStyle) {
          var diff = topic.event.blockIndex - dayEvents.length;

          if (diff > 0) {
            for (var i = 0; i < diff; ++i) {
              dayEvents.push({
                allDay: true,
                empty: true,
                classes: "empty"
              });
              blockIndex++;
            }
          }
        }

        var insertAt = blockStyle ? topic.event.blockIndex : dayEvents.length;
        var replace = 0; // backfill when possible

        var emptyIndexes = [];
        dayEvents.forEach(function (e, i) {
          if (e.empty) emptyIndexes.push(i);
        });

        if (startIsSame && emptyIndexes.length || topic.event.backfill) {
          attrs['backfill'] = true;
          var backfillIndex = emptyIndexes.indexOf(topic.event.blockIndex) > -1 ? topic.event.blockIndex : emptyIndexes[0];

          if (blockStyle) {
            insertAt = topic.event.blockIndex = backfillIndex;
            topic.event.backfill = true;
          } else {
            insertAt = backfillIndex;
          }

          replace = 1;
          blockIndex--;
        }

        dayEvents.splice(insertAt, replace, attrs);
      }

      return dayEvents;
    }, []);
  }

  ;
});
define("discourse/plugins/discourse-events/discourse/routes/preferences-webcal-keys", ["exports", "discourse/routes/restricted-user", "discourse/lib/ajax-error", "discourse/lib/ajax", "@ember/application"], function (_exports, _restrictedUser, _ajaxError, _ajax, _application) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _restrictedUser.default.extend({
    showFooter: true
  });

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/components/add-event-controls"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"event\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"d-button\",null,[[\"class\",\"action\",\"translatedLabel\"],[[24,[\"valueClasses\"]],\"showAddEvent\",[24,[\"valueLabel\"]]]]],false],[0,\"\\n\"],[4,\"unless\",[[24,[\"noText\"]]],null,{\"statements\":[[0,\"    \"],[1,[28,\"d-button\",null,[[\"icon\",\"action\",\"class\"],[\"times\",\"removeEvent\",\"remove\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]},{\"statements\":[[4,\"if\",[[24,[\"iconOnly\"]]],null,{\"statements\":[[0,\"    \"],[1,[28,\"d-button\",null,[[\"class\",\"icon\",\"action\",\"title\"],[\"add-event\",[24,[\"siteSettings\",\"events_event_label_icon\"]],\"showAddEvent\",\"add_event.btn_label\"]]],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"    \"],[1,[28,\"d-button\",null,[[\"class\",\"icon\",\"label\",\"action\",\"title\"],[\"add-event\",[24,[\"siteSettings\",\"events_event_label_icon\"]],\"add_event.btn_label\",\"showAddEvent\",\"add_event.btn_label\"]]],false],[0,\"\\n\"]],\"parameters\":[]}]],\"parameters\":[]}]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/add-event-controls"}});
Ember.TEMPLATES["javascripts/components/add-to-calendar"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"c\"],\"statements\":[[7,\"button\",false],[12,\"class\",\"dropdown-header btn btn-small btn-default\"],[3,\"action\",[[23,0,[]],\"expand\"]],[8],[0,\"\\n  \"],[1,[28,\"d-icon\",[\"far-calendar-plus\"],null],false],[0,\"\\n\"],[4,\"unless\",[[24,[\"site\",\"mobileView\"]]],null,{\"statements\":[[0,\"    \"],[1,[28,\"i18n\",[\"add_to_calendar.label\"],null],false],[0,\"\\n\"]],\"parameters\":[]},null],[9],[0,\"\\n\"],[7,\"div\",true],[11,\"class\",[29,[[28,\"if\",[[24,[\"expanded\"]],\"show\"],null],\" dropdown-menu chooser\"]]],[8],[0,\"\\n  \"],[7,\"ul\",true],[8],[0,\"\\n\"],[4,\"each\",[[24,[\"calendarUris\"]]],null,{\"statements\":[[0,\"      \"],[7,\"li\",true],[8],[7,\"a\",true],[11,\"href\",[29,[[23,1,[\"uri\"]]]]],[10,\"target\",\"_blank\"],[8],[1,[28,\"i18n\",[[28,\"concat\",[\"add_to_calendar.\",[23,1,[\"label\"]]],null]],null],false],[9],[9],[0,\"\\n\"]],\"parameters\":[1]},null],[0,\"  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/add-to-calendar"}});
Ember.TEMPLATES["javascripts/components/date-picker"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"input\",true],[11,\"value\",[22,\"value\"]],[10,\"class\",\"date-picker\"],[10,\"type\",\"text\"],[8],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/date-picker"}});
Ember.TEMPLATES["javascripts/components/event-form"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"div\",true],[10,\"class\",\"event-controls\"],[8],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"control\"],[8],[0,\"\\n    \"],[7,\"input\",true],[11,\"checked\",[22,\"endEnabled\"]],[11,\"onclick\",[28,\"action\",[[23,0,[]],\"toggleEndEnabled\"],[[\"value\"],[\"target.checked\"]]]],[10,\"type\",\"checkbox\"],[8],[9],[0,\"\\n    \"],[7,\"span\",true],[8],[1,[28,\"i18n\",[\"add_event.end_enabled\"],null],false],[9],[0,\"\\n  \"],[9],[0,\"\\n  \\n  \"],[7,\"div\",true],[10,\"class\",\"control\"],[8],[0,\"\\n    \"],[7,\"input\",true],[11,\"checked\",[22,\"allDay\"]],[11,\"onclick\",[28,\"action\",[[23,0,[]],\"toggleAllDay\"],[[\"value\"],[\"target.checked\"]]]],[10,\"type\",\"checkbox\"],[8],[9],[0,\"\\n    \"],[7,\"span\",true],[8],[1,[28,\"i18n\",[\"add_event.all_day\"],null],false],[9],[0,\"\\n  \"],[9],[0,\"\\n  \\n\"],[4,\"unless\",[[24,[\"allDay\"]]],null,{\"statements\":[[0,\"    \"],[7,\"div\",true],[10,\"class\",\"control full-width\"],[8],[0,\"\\n      \"],[1,[28,\"combo-box\",null,[[\"value\",\"valueAttribute\",\"content\",\"none\",\"filterable\"],[[24,[\"timezone\"]],\"value\",[24,[\"timezones\"]],\"add_event.no_timezone\",true]]],false],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[9],[0,\"\\n\\n\"],[7,\"div\",true],[10,\"class\",\"datetime-controls\"],[8],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"start-card date-time-card\"],[8],[0,\"\\n    \"],[7,\"span\",true],[10,\"class\",\"sub-title\"],[8],[0,\"\\n      \"],[1,[28,\"i18n\",[\"add_event.event_start\"],null],false],[0,\"\\n    \"],[9],[0,\"\\n    \\n    \"],[1,[28,\"input-tip\",null,[[\"validation\"],[[24,[\"startDateTimeValidation\"]]]]],false],[0,\"\\n    \\n    \"],[7,\"div\",true],[10,\"class\",\"date-time-set\"],[8],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"date-area\"],[8],[0,\"\\n        \"],[7,\"label\",true],[10,\"class\",\"input-group-label\"],[8],[0,\"\\n          \"],[1,[28,\"i18n\",[\"add_event.event_date\"],null],false],[0,\"\\n        \"],[9],[0,\"\\n        \\n        \"],[1,[28,\"events-date-picker\",null,[[\"value\",\"containerId\"],[[24,[\"startDate\"]],\"date-container-start\"]]],false],[0,\"\\n      \"],[9],[0,\"\\n      \\n\"],[4,\"unless\",[[24,[\"allDay\"]]],null,{\"statements\":[[0,\"        \"],[7,\"div\",true],[10,\"class\",\"time-area\"],[8],[0,\"\\n          \"],[7,\"label\",true],[10,\"class\",\"input-group-label\"],[8],[0,\"\\n            \"],[1,[28,\"i18n\",[\"add_event.event_time\"],null],false],[0,\"\\n          \"],[9],[0,\"\\n          \"],[7,\"input\",true],[10,\"id\",\"start-time-picker\"],[10,\"type\",\"text\"],[8],[9],[0,\"\\n        \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"    \"],[9],[0,\"\\n    \\n    \"],[7,\"div\",true],[10,\"id\",\"date-container-start\"],[8],[9],[0,\"\\n  \"],[9],[0,\"\\n\\n  \"],[7,\"div\",true],[11,\"class\",[29,[\"end-card date-time-card \",[22,\"endClass\"]]]],[8],[0,\"\\n    \"],[7,\"span\",true],[10,\"class\",\"sub-title\"],[8],[0,\"\\n      \"],[1,[28,\"i18n\",[\"add_event.event_end\"],null],false],[0,\"\\n    \"],[9],[0,\"\\n    \\n    \"],[1,[28,\"input-tip\",null,[[\"validation\"],[[24,[\"scheduleDateTimeValidation\"]]]]],false],[0,\"\\n\\t  \\n    \"],[7,\"div\",true],[10,\"class\",\"date-time-set\"],[8],[0,\"\\n      \"],[7,\"div\",true],[10,\"class\",\"date-area\"],[8],[0,\"\\n        \"],[7,\"label\",true],[10,\"class\",\"input-group-label\"],[8],[0,\"\\n          \"],[1,[28,\"i18n\",[\"add_event.event_date\"],null],false],[0,\"\\n        \"],[9],[0,\"\\n        \\n        \"],[1,[28,\"events-date-picker\",null,[[\"value\",\"containerId\"],[[24,[\"endDate\"]],\"date-container-end\"]]],false],[0,\"\\n      \"],[9],[0,\"\\n      \\n\"],[4,\"unless\",[[24,[\"allDay\"]]],null,{\"statements\":[[0,\"        \"],[7,\"div\",true],[10,\"class\",\"time-area\"],[8],[0,\"\\n          \"],[7,\"label\",true],[10,\"class\",\"input-group-label\"],[8],[0,\"\\n            \"],[1,[28,\"i18n\",[\"add_event.event_time\"],null],false],[0,\"\\n          \"],[9],[0,\"\\n          \"],[7,\"input\",true],[10,\"id\",\"end-time-picker\"],[10,\"type\",\"text\"],[8],[9],[0,\"\\n        \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"    \"],[9],[0,\"\\n    \\n    \"],[7,\"div\",true],[10,\"id\",\"date-container-end\"],[8],[9],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"siteSettings\",\"events_rsvp\"]]],null,{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"rsvp-controls\"],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"control\"],[8],[0,\"\\n      \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"rsvpEnabled\"]]]]],false],[0,\"\\n      \"],[7,\"span\",true],[8],[1,[28,\"i18n\",[\"add_event.rsvp_enabled\"],null],false],[9],[0,\"\\n    \"],[9],[0,\"\\n    \\n\"],[4,\"if\",[[24,[\"rsvpEnabled\"]]],null,{\"statements\":[[0,\"      \"],[7,\"div\",true],[10,\"class\",\"rsvp-container\"],[8],[0,\"\\n        \"],[7,\"div\",true],[10,\"class\",\"control\"],[8],[0,\"\\n          \"],[7,\"span\",true],[8],[1,[28,\"i18n\",[\"add_event.going_max\"],null],false],[9],[0,\"\\n          \"],[1,[28,\"input\",null,[[\"type\",\"value\"],[\"number\",[24,[\"goingMax\"]]]]],false],[0,\"\\n        \"],[9],[0,\"\\n\\n        \"],[7,\"div\",true],[10,\"class\",\"control full-width\"],[8],[0,\"\\n          \"],[7,\"span\",true],[8],[1,[28,\"i18n\",[\"add_event.going\"],null],false],[9],[0,\"\\n          \"],[1,[28,\"user-selector\",null,[[\"usernames\",\"class\",\"placeholderKey\"],[[24,[\"usersGoing\"]],\"user-selector\",\"composer.users_placeholder\"]]],false],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"  \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/event-form"}});
Ember.TEMPLATES["javascripts/components/event-rsvp"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"canGo\"]]],null,{\"statements\":[[0,\"  \"],[7,\"button\",false],[12,\"class\",[29,[\"btn btn-small btn-text \",[22,\"goingClasses\"]]]],[3,\"action\",[[23,0,[]],\"going\"]],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"goingSaving\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"loading-spinner\",null,[[\"size\"],[\"small\"]]],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"      \"],[1,[28,\"d-icon\",[\"check\"],null],false],[0,\"\\n\"]],\"parameters\":[]}],[0,\"    \"],[7,\"span\",true],[10,\"class\",\"d-button-label\"],[8],[0,\"\\n      \"],[1,[28,\"i18n\",[\"event_rsvp.going.label\"],null],false],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[7,\"div\",true],[10,\"class\",\"event-rsvp-details\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"hasGuests\"]]],null,{\"statements\":[[4,\"if\",[[24,[\"currentUser\"]]],null,{\"statements\":[[0,\"      \"],[7,\"a\",false],[3,\"action\",[[23,0,[]],\"openModal\"]],[8],[0,\"\\n        \"],[7,\"span\",true],[8],[1,[22,\"goingTotal\"],false],[9],[0,\"\\n        \"],[7,\"span\",true],[8],[1,[28,\"i18n\",[\"event_rsvp.going.label\"],null],false],[9],[0,\"\\n      \"],[9],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"      \"],[7,\"span\",true],[8],[1,[22,\"goingTotal\"],false],[9],[0,\"\\n      \"],[7,\"span\",true],[8],[1,[28,\"i18n\",[\"event_rsvp.going.label\"],null],false],[9],[0,\"\\n\"]],\"parameters\":[]}]],\"parameters\":[]},null],[4,\"if\",[[24,[\"goingMessage\"]]],null,{\"statements\":[[0,\"    \"],[7,\"span\",true],[10,\"class\",\"going-message\"],[8],[0,\"\\n      \"],[1,[22,\"goingMessage\"],false],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/event-rsvp"}});
Ember.TEMPLATES["javascripts/components/event-webcal-keys"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"apiKey\"]]],null,{\"statements\":[[0,\"    \"],[7,\"div\",true],[10,\"class\",\"events-webcal-api\"],[8],[0,\"\\n      \"],[7,\"label\",true],[10,\"class\",\"webcal-label\"],[8],[1,[28,\"i18n\",[\"webcal_preferences.api_key\"],null],false],[9],[7,\"pre\",true],[8],[1,[22,\"apiKey\"],false],[9],[0,\"      \"],[7,\"label\",true],[10,\"class\",\"webcal-label\"],[8],[1,[28,\"i18n\",[\"webcal_preferences.client_id\"],null],false],[9],[7,\"pre\",true],[8],[1,[22,\"clientID\"],false],[9],[0,\"      \"],[7,\"p\",true],[10,\"class\",\"webcal-notice\"],[8],[1,[28,\"i18n\",[\"webcal_preferences.notice\"],null],false],[9],[0,\"  \\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[1,[28,\"d-button\",null,[[\"action\",\"class\",\"label\"],[[28,\"action\",[[23,0,[]],\"show\"],null],\"btn-primary\",\"webcal_preferences.generate\"]]],false],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/event-webcal-keys"}});
Ember.TEMPLATES["javascripts/components/events-calendar-body"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"day\",\"index\",\"w\"],\"statements\":[[4,\"each\",[[24,[\"weekdays\"]]],null,{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"weekday\"],[8],[0,\"\\n    \"],[7,\"span\",true],[8],[1,[23,3,[]],false],[9],[0,\"\\n  \"],[9],[0,\"\\n\"]],\"parameters\":[3]},null],[0,\"\\n\"],[4,\"each\",[[24,[\"days\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"events-calendar-day\",null,[[\"day\",\"currentDate\",\"currentMonth\",\"selectDate\",\"canSelectDate\",\"expandedDate\",\"setExpandedDate\",\"showEvents\",\"topics\",\"responsive\",\"index\"],[[23,1,[]],[24,[\"currentDate\"]],[24,[\"currentMonth\"]],\"selectDate\",[24,[\"canSelectDate\"]],[24,[\"expandedDate\"]],[28,\"action\",[[23,0,[]],\"setExpandedDate\"],null],[24,[\"showEvents\"]],[24,[\"topics\"]],[24,[\"responsive\"]],[23,2,[]]]]],false],[0,\"\\n\"]],\"parameters\":[1,2]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/events-calendar-body"}});
Ember.TEMPLATES["javascripts/components/events-calendar-card"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"a\",false],[12,\"class\",\"topic-link\"],[3,\"action\",[[23,0,[]],\"goToTopic\"]],[8],[0,\"\\n  \"],[1,[22,\"cookedTitle\"],false],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"a\",false],[12,\"class\",\"close\"],[3,\"action\",[[23,0,[]],\"close\"]],[8],[0,\"\\n  \"],[1,[28,\"d-icon\",[\"times\"],null],false],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"div\",true],[10,\"class\",\"topic-meta\"],[8],[0,\"\\n  \"],[1,[28,\"category-link\",[[24,[\"topic\",\"category\"]]],null],false],[0,\"\\n  \"],[1,[28,\"discourse-tags\",[[24,[\"topic\"]]],[[\"mode\"],[\"list\"]]],false],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"div\",false],[12,\"class\",\"topic-event event-label\"],[3,\"action\",[[23,0,[]],\"goToTopic\"]],[8],[0,\"\\n  \"],[1,[28,\"event-label\",[[24,[\"topic\",\"event\"]]],null],false],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"div\",false],[12,\"class\",\"topic-excerpt\"],[3,\"action\",[[23,0,[]],\"goToTopic\"]],[8],[0,\"\\n  \"],[1,[22,\"cookedExcerpt\"],false],[0,\"\\n\"],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/events-calendar-card"}});
Ember.TEMPLATES["javascripts/components/events-calendar-day"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"div\",true],[10,\"class\",\"container\"],[11,\"style\",[22,\"containerStyle\"]],[8],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"header\"],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"date\"],[8],[0,\"\\n      \"],[7,\"label\",true],[8],[1,[22,\"date\"],false],[9],[0,\"\\n    \"],[9],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"expanded\"]]],null,{\"statements\":[[0,\"      \"],[7,\"div\",false],[12,\"class\",\"close\"],[3,\"action\",[[23,0,[]],[24,[\"setExpandedDate\"]],null]],[8],[1,[28,\"d-icon\",[\"times\"],null],false],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"  \"],[9],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"events\"]]],null,{\"statements\":[[4,\"if\",[[24,[\"showEvents\"]]],null,{\"statements\":[[0,\"      \"],[7,\"div\",true],[10,\"class\",\"events\"],[8],[0,\"\\n        \"],[1,[28,\"events-calendar-events\",null,[[\"events\"],[[24,[\"events\"]]]]],false],[0,\"\\n      \"],[9],[0,\"\\n\"],[4,\"if\",[[24,[\"hasHidden\"]]],null,{\"statements\":[[0,\"        \"],[7,\"div\",true],[10,\"class\",\"hidden-events\"],[8],[0,\"\\n          \"],[1,[28,\"d-button\",null,[[\"class\",\"translatedLabel\",\"action\",\"actionParam\"],[\"btn-small\",[28,\"i18n\",[\"events_calendar.hidden\"],[[\"count\"],[[24,[\"hidden\"]]]]],[24,[\"setExpandedDate\"]],[24,[\"date\"]]]]],false],[0,\"\\n        \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]},{\"statements\":[[0,\"      \"],[7,\"div\",true],[10,\"class\",\"has-events\"],[8],[0,\"\\n        \"],[1,[28,\"d-icon\",[\"circle\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n\"]],\"parameters\":[]}]],\"parameters\":[]},null],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/events-calendar-day"}});
Ember.TEMPLATES["javascripts/components/events-calendar-event"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"div\",false],[12,\"class\",[29,[[24,[\"event\",\"classes\"]]]]],[12,\"style\",[24,[\"event\",\"listStyle\"]]],[3,\"action\",[[23,0,[]],\"selectEvent\",[24,[\"event\",\"topic\",\"url\"]]]],[8],[0,\"\\n\"],[4,\"unless\",[[24,[\"event\",\"allDay\"]]],null,{\"statements\":[[0,\"    \"],[7,\"span\",true],[11,\"style\",[24,[\"event\",\"dotStyle\"]]],[8],[1,[28,\"d-icon\",[\"circle\"],null],false],[9],[0,\"\\n\"]],\"parameters\":[]},null],[4,\"if\",[[24,[\"event\",\"time\"]]],null,{\"statements\":[[0,\"    \"],[7,\"span\",true],[10,\"class\",\"time\"],[8],[1,[24,[\"event\",\"time\"]],false],[9],[0,\"\\n\"]],\"parameters\":[]},null],[4,\"if\",[[24,[\"event\",\"title\"]]],null,{\"statements\":[[0,\"    \"],[7,\"span\",true],[10,\"class\",\"title\"],[11,\"style\",[24,[\"event\",\"titleStyle\"]]],[8],[1,[28,\"replace-emoji\",[[24,[\"event\",\"title\"]]],null],false],[9],[0,\"\\n\"]],\"parameters\":[]},null],[9],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"showEventCard\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"events-calendar-card\",null,[[\"topic\",\"selectEvent\"],[[24,[\"event\",\"topic\"]],\"selectEvent\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/events-calendar-event"}});
Ember.TEMPLATES["javascripts/components/events-calendar-events"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"event\"],\"statements\":[[4,\"each\",[[24,[\"events\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"events-calendar-event\",null,[[\"event\",\"responsive\"],[[23,1,[]],[24,[\"responsive\"]]]]],false],[0,\"\\n\"]],\"parameters\":[1]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/events-calendar-events"}});
Ember.TEMPLATES["javascripts/components/events-calendar-subscription-row"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"copiedUrl\"]]],null,{\"statements\":[[0,\"  \"],[7,\"span\",true],[10,\"class\",\"copied\"],[8],[1,[28,\"i18n\",[\"copy_codeblock.copied\"],null],false],[9],[0,\"\\n\"]],\"parameters\":[]},null],[7,\"span\",true],[10,\"class\",\"name\"],[8],[1,[22,\"label\"],false],[9],[0,\"\\n\"],[1,[28,\"input\",null,[[\"value\"],[[24,[\"item\",\"id\"]]]]],false],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/events-calendar-subscription-row"}});
Ember.TEMPLATES["javascripts/components/events-calendar-subscription-warning"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"div\",true],[10,\"class\",\"events-calendar-subscription-warning\"],[8],[0,\"\\n  \"],[1,[28,\"d-icon\",[\"exclamation-triangle\"],null],false],[0,\"\\n  \"],[1,[28,\"I18n\",[\"events_calendar.subscription.warning\"],null],false],[0,\"\\n\"],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/events-calendar-subscription-warning"}});
Ember.TEMPLATES["javascripts/components/events-calendar"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"div\",true],[10,\"class\",\"header\"],[8],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"navigation\"],[8],[0,\"\\n    \"],[1,[28,\"d-button\",null,[[\"label\",\"action\",\"icon\"],[[24,[\"todayLabel\"]],\"today\",\"calendar\"]]],false],[0,\"\\n    \"],[1,[28,\"d-button\",null,[[\"icon\",\"action\"],[\"chevron-left\",\"monthPrevious\"]]],false],[0,\"\\n    \"],[1,[28,\"d-button\",null,[[\"icon\",\"action\"],[\"chevron-right\",\"monthNext\"]]],false],[0,\"\\n    \"],[1,[28,\"combo-box\",null,[[\"content\",\"value\",\"class\"],[[24,[\"months\"]],[24,[\"month\"]],\"month-dropdown\"]]],false],[0,\"\\n    \"],[1,[28,\"combo-box\",null,[[\"content\",\"value\",\"class\"],[[24,[\"years\"]],[24,[\"year\"]],\"year-dropdown\"]]],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[4,\"if\",[[24,[\"showSubscription\"]]],null,{\"statements\":[[0,\"    \"],[1,[28,\"events-calendar-subscription\",null,[[\"category\",\"userApiKeys\",\"options\"],[[24,[\"category\"]],[24,[\"userApiKeys\"]],[28,\"hash\",null,[[\"showFullTitle\",\"icon\",\"none\"],[[24,[\"showFullTitle\"]],\"rss\",\"events_calendar.subscribe\"]]]]]],false],[0,\"\\n\"],[4,\"if\",[[24,[\"showNotice\"]]],null,{\"statements\":[[0,\"        \"],[7,\"ul\",true],[10,\"class\",\"events-webcal-notices\"],[8],[0,\"\\n          \"],[7,\"li\",true],[8],[1,[28,\"html-safe\",[[28,\"i18n\",[\"webcal_preferences.calendar_notice\"],[[\"link\"],[\"/my/preferences/webcal-keys\"]]]],null],false],[9],[0,\"\\n          \"],[7,\"li\",true],[8],[1,[28,\"html-safe\",[[28,\"i18n\",[\"webcal_preferences.calendar_usage\"],[[\"doc\"],[\"https://thepavilion.io/t/subscribing-to-events-ical-and-rss-feeds/2883\"]]]],null],false],[9],[0,\"\\n        \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]},null],[9],[0,\"\\n\"],[1,[28,\"events-calendar-body\",null,[[\"days\",\"topics\",\"currentMonth\",\"currentDate\",\"selectDate\",\"canSelectDate\",\"showEvents\",\"responsive\"],[[24,[\"days\"]],[24,[\"topics\"]],[24,[\"currentMonth\"]],[24,[\"currentDate\"]],\"selectDate\",[24,[\"canSelectDate\"]],[24,[\"showEvents\"]],[24,[\"responsive\"]]]]],false],[0,\"\\n\"],[4,\"if\",[[24,[\"eventsBelow\"]]],null,{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"events-below\"],[8],[0,\"\\n    \"],[1,[28,\"events-calendar-events\",null,[[\"events\",\"responsive\"],[[24,[\"dateEvents\"]],[24,[\"responsive\"]]]]],false],[0,\"\\n  \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/events-calendar"}});
Ember.TEMPLATES["javascripts/discovery/calendar"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[1,[28,\"events-calendar\",null,[[\"topics\",\"category\",\"loading\",\"initialDateRange\"],[[24,[\"model\",\"topics\"]],[24,[\"category\"]],[24,[\"discovery\",\"loading\"]],[24,[\"initialDateRange\"]]]]],false],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/discovery/calendar"}});
Ember.TEMPLATES["javascripts/modal/add-event"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"d-modal-body\",null,[[\"class\",\"id\",\"title\"],[\"add-event-modal\",\"event-modal\",[24,[\"title\"]]]],{\"statements\":[[0,\"  \"],[1,[28,\"event-form\",null,[[\"event\",\"updateEvent\"],[[24,[\"model\",\"event\"]],[28,\"action\",[[23,0,[]],\"updateEvent\"],null]]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[7,\"div\",true],[10,\"class\",\"modal-footer\"],[8],[0,\"\\n  \"],[1,[28,\"d-button\",null,[[\"action\",\"class\",\"label\"],[\"saveEvent\",\"btn-primary\",\"add_event.event_add\"]]],false],[0,\"\\n  \"],[7,\"a\",false],[12,\"class\",\"clear\"],[3,\"action\",[[23,0,[]],\"clear\"]],[8],[1,[28,\"i18n\",[\"add_event.event_clear\"],null],false],[9],[0,\"\\n\"],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/modal/add-event"}});
Ember.TEMPLATES["javascripts/modal/event-rsvp"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"user\"],\"statements\":[[4,\"d-modal-body\",null,[[\"class\",\"title\"],[\"event-rsvp-modal\",\"event_rsvp.modal.title\"]],{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"header\"],[8],[0,\"\\n    \"],[7,\"ul\",true],[10,\"class\",\"types nav nav-pills\"],[8],[0,\"\\n      \"],[7,\"li\",true],[11,\"class\",[29,[[22,\"goingNavClass\"]]]],[8],[0,\"\\n        \"],[7,\"a\",false],[3,\"action\",[[23,0,[]],\"setType\",\"going\"]],[8],[0,\"\\n          \"],[1,[28,\"i18n\",[\"event_rsvp.going.label\"],null],false],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n    \"],[7,\"span\",true],[10,\"class\",\"filter\"],[8],[0,\"\\n      \"],[1,[28,\"input\",null,[[\"value\",\"placeholder\"],[[24,[\"filter\"]],[28,\"i18n\",[\"event_rsvp.modal.filter\"],null]]]],false],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"list\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"loadingList\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"loading-spinner\",null,[[\"size\"],[\"small\"]]],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"      \"],[7,\"ul\",true],[8],[0,\"\\n\"],[4,\"each\",[[24,[\"filteredList\"]]],null,{\"statements\":[[0,\"          \"],[7,\"li\",true],[8],[0,\"\\n\"],[4,\"user-info\",null,[[\"user\"],[[23,1,[]]]],{\"statements\":[[4,\"if\",[[23,1,[\"can_send_private_message_to_user\"]]],null,{\"statements\":[[0,\"                \"],[1,[28,\"d-button\",null,[[\"class\",\"action\",\"actionParam\",\"icon\",\"label\"],[\"btn compose-pm\",\"composePrivateMessage\",[23,1,[]],\"envelope\",\"user.private_message\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]},null],[0,\"          \"],[9],[0,\"\\n\"]],\"parameters\":[1]},null],[0,\"      \"],[9],[0,\"\\n\"]],\"parameters\":[]}],[0,\"  \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/modal/event-rsvp"}});
Ember.TEMPLATES["javascripts/preferences/webcal-keys"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"label\",true],[10,\"class\",\"control-label\"],[8],[1,[28,\"i18n\",[\"webcal_preferences.heading\"],null],false],[9],[0,\"\\n\"],[1,[22,\"event-webcal-keys\"],false],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/preferences/webcal-keys"}});
define("discourse/plugins/discourse-events/wizard/components/wizard-field-event", ["exports", "@ember/component", "@ember/object/computed"], function (_exports, _component, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _component.default.extend({
    layoutName: "javascripts/wizard/templates/components/wizard-field-event",
    eventTimezones: (0, _computed.alias)('field.event_timezones'),
    actions: {
      updateEvent: function updateEvent(event, status) {
        this.set('field.value', event);
        this.field.setValid(status);
      }
    }
  });

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/wizard/templates/components/wizard-field-event"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[1,[28,\"event-form\",null,[[\"event\",\"eventTimezones\",\"updateEvent\"],[[24,[\"event\"]],[24,[\"eventTimezones\"]],[28,\"action\",[[23,0,[]],\"updateEvent\"],null]]]],false],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/wizard/templates/components/wizard-field-event"}});

